import { ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import * as jquery from 'jquery';
import * as _ from 'lodash';
import { isBoolean, isNumber, isNullOrUndefined } from '../../models//utils';
import { ScrollablePopoverDirective } from '../../directives/scrollable-popover/scrollable-popover.directive';
import { DataArea } from '../../models/data-area';
import { DrObject, SupportedRegExType } from '../../models/dr-object';
import { ConnectorType, DREnumType, Endpoint, MessageType, ReviewSystem, SizeUnits } from '../../models/enums';
import { ExportMetadataProfile } from '../../models/export-metadata-profile';
import { ExportDatabaseTableViewModel } from '../../models/export-database';
import { ExportStream, ExportStreamViewModel } from '../../models/export-stream';
import {
    BegAttachMode, EmailOptions, EmailOutputFormat, ExportDisabled, ExportDocumentsToExport, ExportDuplicateMode, ExportExtraOptions,
    ExportOnChange, ExportStamping, ExportStreamOptions, ExportTarget, ExportValidation, ProductionStamp, StampPosition, StampType, TiffMode,
    ExportStreamOptionsViewModel,
    ExportInputName
} from '../../models/export-stream-options';
import { ExportVolume } from '../../models/export-volume';
import { Tag } from '../../models/tag';
import { Template, TemplateType } from '../../models/template';
import { Timezone } from '../../models/timezone';
import { CommonService } from '../../services/common/common.service';
import { RestService } from '../../services/rest/rest.service';
import { SearchConfig, SearchWrapper, XMLService } from '../../services/xml/xml.service';
import { BulkSearchComponent } from '../bulk-search/bulk-search.component';
import { GenericPickerModalComponent } from '../modals/generic-picker-modal/generic-picker-modal.component';
import { TimezoneModalComponent } from '../modals/timezone-preferences/timezone-modal.component';
import { ExportOutputFormattingOptionsComponent } from './export-output-formatting-options/export-output-formatting-options.component';
import { ExportProductionImagingOptionsComponent } from './export-production-imaging-options/export-production-imaging-options.component';
import { NameDescriptionComponent } from '../name-description/name-description.component';
import { DeferredPromise } from '../../models/deferred-promise';
import { Subscription } from 'rxjs';
import { ActionType, ObjectActionListType, Permissions } from '../../models/permission';
import { SelectDocumentFolderModalComponent } from '../modals/select-document-folder-modal/select-document-folder-modal/select-document-folder-modal.component';
import { CustomComboBoxComponent } from '../custom-combo-box/custom-combo-box.component';
import { MAXIMUM_EMBEDDED_TEXT_SIZE, REEF_REVIEW_OVERLAY_FIELD_SETTINGS } from '../../models/constants';
import { GenericTreeNode } from '../generic-tree/generic-tree-node';

@Component({
    standalone: false,
    selector: 'res-export',
    templateUrl: './export.component.html',
    styleUrls: ['./export.component.scss']
})
export class ExportComponent implements OnInit, OnDestroy {
    readonly EmailOptions = EmailOptions;
    readonly currentBrowserIsIE = this.commonService.currentBrowserIsIE;
    readonly DEFAULT_FOLDER_BTN_LABEL = 'Select ...';
    @HostBinding('class') classes = 'maximized-component';
    @ViewChild(ExportOutputFormattingOptionsComponent, { static: false }) exportOutputFormattingOptionsComponent: ExportOutputFormattingOptionsComponent;
    @ViewChild(ExportProductionImagingOptionsComponent, { static: true }) exportProductionImagingOptionsComponent: ExportProductionImagingOptionsComponent;
    @ViewChild(BulkSearchComponent) bulkSearchComponent: BulkSearchComponent;
    @ViewChildren(ScrollablePopoverDirective) errorPopovers: QueryList<ScrollablePopoverDirective>;
    @ViewChild('streamNameComboBox', { static: false }) streamNameComboBox: CustomComboBoxComponent;
    @Input() selectedExportStream: ExportStream;
    @Input() selectedExportVolume: ExportVolume;
    @Input() automationId: string;
    @Input() isupdateExportVolume = false;
    @Input() isExportToRelativity = false;
    @Input() isReefReviewProject = false;
    @Input() exportOptionsFromUpdateExportVolume: ExportStreamOptions;
    @Input() exportSettingsOptions: ExportStreamOptions;
    @Input() disabledFields: ExportDisabled;
    @Input() enableSearchTermQueries: boolean;
    // export settings
    @Input() isExportSettingsPage = false;
    @Input() isProjectSettings = false;
    @Output() dirtyStateChanged = new EventEmitter<boolean>();
    private focusFieldEvent: Subscription;

    selectedDataAreaName = '';
    isReefReviewWithConnector: boolean;
    documentFolderPath = this.DEFAULT_FOLDER_BTN_LABEL;
    folderByOptions: Array<string>;

    ReviewSystem = ReviewSystem;
    currentReviewSystem = ReviewSystem.NONE;

    get filteredExportDataAreas(): Array<DataArea> {
        if (!this.optionsDisabled && this.currentReviewSystem === ReviewSystem.RELATIVITY) {
            return this.extraOptions.exportDataAreas.filter(da => da.connectorType === ConnectorType.CIFS);
        }
        return this.extraOptions.exportDataAreas;
    }

    private _isBusy: boolean;
    get isBusy(): boolean {
        return this._isBusy;
    }
    @Input()
    set isBusy(val: boolean) {
        if (this._isBusy !== val) {
            this._isBusy = val;
            this.isBusyChange.emit(this._isBusy);
        }
    }
    @Output() isBusyChange = new EventEmitter<boolean>();

    private _isBusyMessage: string;
    get isBusyMessage(): string {
        return this._isBusyMessage;
    }
    @Input()
    set isBusyMessage(val: string) {
        if (this._isBusyMessage !== val) {
            this._isBusyMessage = val;
            this.isBusyMessageChange.emit(this._isBusyMessage);
        }
    }
    @Output() isBusyMessageChange = new EventEmitter<string>();

    exportStreamViewModel = new ExportStreamViewModel();
    exportDatabaseTableViewModel = new ExportDatabaseTableViewModel();
    exportOptions: ExportStreamOptions;
    isExportVolume: boolean;
    isNewExport: boolean;
    isNewIdPrefix: boolean;
    defaultExport: boolean;
    selectedId = '0000000001';
    isItemClick: boolean;
    prefixString: string;
    selectedExportStreamClicked: string;
    warningMessage = 'Up to 50 characters are allowed. One or more characters were trimmed at the end.';
    documentIdPadSize: number;
    nameAlreadyExists = [];
    lastItemCliked: boolean;
    exportNameChangedByTyping: boolean;
    isHyland: boolean;
    customTaskDescription = 'Validating Search Terms for Export';
    isFolderPathSelected = false;
    isRelativityReviewSystem = false;
    availableReviewProjects = [];
    volumeLabelFromOptions: string;

    @Input() optionsDisabled: boolean;

    exportStreamNameDescriptionComponent: NameDescriptionComponent;
    tableNameDescriptionComponent: NameDescriptionComponent;
    tableNameNeedsValidation = false;
    exportNameNeedsValidation = false;
    maxTableNameLength = ExportStreamOptionsViewModel.EXPORT_OPTION_TABLE_NAME_MAX_LENGTH;
    fieldInFocus: boolean;
    isSystemUserWithPermissions = false;
    selectedFolderPath = this.DEFAULT_FOLDER_BTN_LABEL;
    exportSettingsNearDuplicatedThreshold: number;
    exportSettingsNearDuplicatedMinTermCount: number;
    defaultNativeSubdirectoryName: string;
    defaultExtractedTextName: string;
    defaultEmailOutputFormat: EmailOutputFormat;
    defaultExcludeEmailHeaders: boolean;
    defaultHighlightSearchTermsSelection: boolean;
    defaultGenerateRemainingImagesSelection: boolean;

    extraOptions: ExportExtraOptions = {
        isBusy: new Array<Endpoint>(),
        exportStreams: new Array<ExportStream>(),
        exportStreamNames: new Array<string>(),
        exportStreamName: '',
        exportDataAreas: new Array<DataArea>(),
        exportFieldTemplates: {
            project: new Array<ExportMetadataProfile | Template>(),
            organization: new Array<ExportMetadataProfile | Template>(),
            system: new Array<ExportMetadataProfile | Template>()
        },
        exportSettingsTemplates: {
            project: new Array<ExportMetadataProfile | Template>(),
            organization: new Array<ExportMetadataProfile | Template>(),
            system: new Array<ExportMetadataProfile | Template>()
        },
        includeFullText: false,
        selectedExportDatabaseConnection: null,
        maxRecordsPerFile: false,
        timezones: new Array<Timezone>(),
        allTimezones: new Array<Timezone>(),
        prevSelectedTimezone: null,
        dateFormats: ['MM/dd/yyyy', 'MM/dd/yy', 'yy/MM/dd', 'yyyy/MM/dd', 'dd/MMM/yy'],
        delimiters: [';', '-', 'Space'],
        timeFormats: ['HH:mm:ss', 'hh:mm:ss a', 'h:mm:ss a'],
        documentPrefixes: ['CTRL', 'DOC'],
        startingDocumentIdDisplay: ExportStreamOptionsViewModel.DEFAULT_STARTING_ID,
        generateSearchReports: false,
        metadataProperties: new Array<string>()
    };

    private markAsDirty(): void {
        this.dirtyStateChanged.emit(true);
    }

    public markAsClean(): void {
        this.dirtyStateChanged.emit(false);
    }

    onChange: ExportOnChange = {
        exportStreamName: (name: string, isItemClick: boolean) => {
            this.isItemClick = isItemClick;
            this.validation.startingDocumentId.hasError = false;
            if (!isItemClick) {
                this.exportNameChangedByTyping = this.extraOptions.exportStreamNames.includes(name) ? !this.lastItemCliked : true;
                this.validation.exportStreamName.check(name);
            } else {
                this.lastItemCliked = true;
                this.selectedExportStreamClicked = name;
                this.validation.exportStreamName.invalid = false;
                this.validation.exportStreamName.hasError = false;
            }
            if (!this.validation.exportStreamName.invalid) {
                if (!this.disabled.exportToDb()) {
                    if (isNullOrUndefined(this.tableNameDescriptionComponent.name) || DrObject.isEmpty(this.tableNameDescriptionComponent.name)) {
                        this.formatTableName(this.commonService.currentProject?.name, this.extraOptions.exportStreamName);
                    }
                }
                const isExistingExport = this.extraOptions.exportStreamNames.filter(es => es.toLowerCase() === name.toLowerCase()).length > 0;
                if (isExistingExport) {
                    this.selectedExportStream = this.extraOptions.exportStreams.filter(es => es.name.toLowerCase() === name.toLowerCase()).pop();
                    if (this.selectedExportStream && isItemClick) {
                        this.setReviewSystemFromOptions(this.selectedExportStream.options?.reviewSystem);
                        this.loadExportStreamOptions();
                        this.validation.exportStreamName.validateName(name, true);
                    }
                } else {
                    // new export, enable inputs
                    if (this.lastItemCliked) {
                        this.defaultExport = true;
                        this.defaultExportOptions();
                        this.extraOptions.startingDocumentIdDisplay = ExportStreamOptionsViewModel.DEFAULT_STARTING_ID;
                        this.exportOptions.documentIdPadSize = 10;
                        this.lastItemCliked = false;
                    }
                    this.isExportVolume = false;
                    this.isNewExport = true;
                    this.defaultExport = true;
                    this.selectedExportStreamClicked = '';
                    this.selectedId = ExportStreamOptionsViewModel.DEFAULT_STARTING_ID;
                    this.validation.startingDocumentId.parse();
                }
            }
        },
        tableName: {
            keyboard: (): void => {
                this.tableNameNeedsValidation = true;
                this.tableNameCheck();
                this.markAsDirty();
            },
            paste: (text: string): void => {
                this.tableNameNeedsValidation = true;
                if (!isNullOrUndefined(text)) {
                    text.trim();
                    this.exportOptions.tableName = this.maxTableNameLength ? text.substr(0, this.maxTableNameLength) : text;
                    this.tableNameCheck();
                    this.markAsDirty();
                }
            },
        },
        emailOptions: (emailOptions: EmailOptions) => {
            this.exportOptions.emailOptions = emailOptions;
            const preserveValues = this.isExportSettingsPage;

            this.exportOptions.includeSeperateEmailAttachments = preserveValues ? this.exportOptions.includeSeperateEmailAttachments : true;
            this.exportOptions.includePdfOLEChildren = preserveValues ? this.exportOptions.includePdfOLEChildren : true;
            this.exportOptions.includeOLEChildren = preserveValues ? this.exportOptions.includeOLEChildren : false;
            this.exportOptions.includeContainerReferences = preserveValues ? this.exportOptions.includeContainerReferences : false;
            this.exportOptions.removeAttachedArchives = preserveValues ? this.exportOptions.removeAttachedArchives : true;
            this.markAsDirty();
        },
        includeSeperateEmailAttachments: (includeSeperateEmailAttachments?: boolean) => {
            if (includeSeperateEmailAttachments) {
                this.exportOptions.includeSeperateEmailAttachments = includeSeperateEmailAttachments;
            }
            if (!this.exportOptions.includeSeperateEmailAttachments && !this.exportOptions.includePdfOLEChildren) {
                this.exportOptions.includeThreadAttach = false;
                this.exportOptions.nearDuplicatesProcessAttachments = false;
            }
            if (!this.exportOptions.includeSeperateEmailAttachments) {
                this.extraOptions.generateSearchReports = false;
                this.exportOptions.highlightTerms = false;
            }
            this.exportOptions.emailOutputFormat = this.exportOptions.includeNativeFiles && this.exportOptions.includeSeperateEmailAttachments && !this.isExportSettingsPage ? EmailOutputFormat.HTML_MHTML_FORMAT : this.isExportSettingsPage ? this.exportOptions.emailOutputFormat : null;
            this.markAsDirty();
        },
        includeContainerReferences: (includeContainerReferences: boolean, isExportSettingsPageLoading?: boolean) => {
            if (isExportSettingsPageLoading) {
                return;
            }
            this.exportOptions.includeContainerReferences = isExportSettingsPageLoading ? includeContainerReferences : this.exportOptions.includeContainerReferences;
            this.markAsDirty();
        },
        removeAttachedArchives: () => {
            this.markAsDirty();
        },
        createReviewSystemFolder: () => {
            this.documentFolderPath = this.exportOptions.createReviewFolder ? 'All Document Folders' : this.selectedFolderPath;
            this.isFolderPathSelected = !this.exportOptions.createReviewFolder && this.documentFolderPath !== this.DEFAULT_FOLDER_BTN_LABEL ? true : false;
            if (!this.exportOptions.createReviewFolder && (!this.exportOptions.volumeLabel || this.exportOptions.volumeLabel === '')) {
                this.exportOptions.volumeLabel = this.volumeLabelFromOptions;
            }
            this.validation.volumeLabel.check();
        },
        includePdfOLEChildren: () => {
            if (!this.exportOptions.includePdfOLEChildren) {
                this.exportOptions.includeOLEChildren = false;
                if (!this.exportOptions.includeSeperateEmailAttachments) {
                    this.exportOptions.includeThreadAttach = false;
                    this.exportOptions.nearDuplicatesProcessAttachments = false;
                }
            }
            this.markAsDirty();
        },
        excludeEmailHeadersInLoadFile: () => {
            this.markAsDirty();
        },
        separateDupeManifest: () => {
            this.markAsDirty();
        },
        includeAllMasterDuplicates: () => {
            this.markAsDirty();
        },
        includeThreadAttach: () => {
            this.markAsDirty();
        },
        overlayManifest: () => {
            if (!this.exportOptions.overlayManifest) {
                this.exportOptions.includeAllMasterDuplicates = false;
                this.exportOptions.overlayMetadataTemplateHandle = '';
            }
            this.markAsDirty();
        },
        overlayMetadataTemplateHandle: () => {
            this.markAsDirty();
        },
        includeFullText: () => {
            if (this.isExportSettingsPage) {
                this.exportOptions.includeFullText = this.extraOptions.includeFullText;
            }
            if (!this.extraOptions.includeFullText || this.disabled.includeFullText()) {
                this.exportOptions.excludeEmailHeadersInLoadFile = false;
            }
            this.markAsDirty();
        },
        manifestSizeUnits: () => {
            this.markAsDirty();
        },
        exportDuplicateMode: () => {
            this.exportOptions.separateDupeManifest = false;
            this.markAsDirty();
        },
        pageLevelNumbering: () => {
            this.markAsDirty();
        },
        pageSeperator: () => {
            this.markAsDirty();
        },
        emailOutputFormat: () => {
            this.markAsDirty();
        },
        excludeEmailHeaders: () => {
            this.markAsDirty();
        },
        includeOLEChildren: () => {
            this.markAsDirty();
        },
        includeNearDuplicates: () => {
            if (this.isExportSettingsPage && !this.exportSettingsNearDuplicatedThreshold && !this.exportSettingsNearDuplicatedMinTermCount) {
                this.exportSettingsNearDuplicatedThreshold = this.exportOptions.nearDuplicatesThreshold;
                this.exportSettingsNearDuplicatedMinTermCount = this.exportOptions.nearDuplicatesMinTermCount;
            }
            this.exportOptions.nearDuplicatesThreshold = this.exportOptions.includeNearDuplicates ? 80 : this.isExportSettingsPage ? this.exportSettingsNearDuplicatedThreshold : 80;
            this.validation.nearDuplicatesThreshold.invalid = false;
            this.validation.nearDuplicatesThreshold.hasError = false;
            this.exportOptions.nearDuplicatesMinTermCount = this.exportOptions.includeNearDuplicates ? 25 : this.isExportSettingsPage ? this.exportSettingsNearDuplicatedMinTermCount : 25;
            this.validation.nearDuplicatesMinTermCount.invalid = false;
            this.validation.nearDuplicatesMinTermCount.hasError = false;
            this.exportOptions.nearDuplicatesProcessAttachments = false;
            this.markAsDirty();
        },
        nearDuplicatesProcessAttachments: () => {
            this.markAsDirty();
        },
        begAttachMode: () => {
            this.markAsDirty();
        },
        concordanceUnicodeFormat: () => {
            this.markAsDirty();
        },
        includeVolumeLabelInPath: () => {
            this.markAsDirty();
        },
        startingDocumentId: () => {
            if (this.isExportSettingsPage) {
                const startDocIdDisplay = this.extraOptions.startingDocumentIdDisplay;
                this.exportOptions.updatedStartingDocumentId = parseInt(startDocIdDisplay, 10);
                this.markAsDirty();
            }
        },
        idPrefix: (id: string) => {
            this.validation.documentIdPrefix.check(id);
            if (id && !this.validation.documentIdPrefix.invalid) {
                if (this.extraOptions.documentPrefixes.includes(id)) {
                    if (this.isNewExport) {
                        this.extraOptions.startingDocumentIdDisplay = ExportStreamOptionsViewModel.DEFAULT_STARTING_ID;
                        this.selectedId = this.extraOptions.startingDocumentIdDisplay;
                        this.exportOptions.startingDocumentId = 1;
                    }
                    this.isNewIdPrefix = false;
                    this.extraOptions.startingDocumentIdDisplay = this.exportOptions.docIdsByPrefix && this.exportOptions.docIdsByPrefix[id] ?
                        (this.exportOptions.docIdsByPrefix[id]).toString().padStart(this.exportOptions.documentIdPadSize, '0') : this.extraOptions.startingDocumentIdDisplay;
                    this.selectedId = this.extraOptions.startingDocumentIdDisplay;
                    this.exportOptions.startingDocumentId = this.validation.startingDocumentId.defaultStartingDocumentId;
                } else {
                    this.isNewIdPrefix = true;
                    this.extraOptions.startingDocumentIdDisplay = ExportStreamOptionsViewModel.DEFAULT_STARTING_ID;
                    this.selectedId = ExportStreamOptionsViewModel.DEFAULT_STARTING_ID;
                    this.exportOptions.startingDocumentId = 1;
                }
            }
        },
        outputOptions: (optionName: string) => {
            switch (optionName) {
                case 'DAT': {
                    // exportOptions.generateConcordance
                    this.exportOptions.concordanceUnicodeFormat = this.exportOptions.generateConcordance ? true : null;
                    if (!this.exportOptions.generateConcordance && !this.exportOptions.generateCsv && !this.exportOptions.generateEdrmXml) {
                        this.extraOptions.maxRecordsPerFile = false;
                        this.validation.maxManifestRecords.invalid = false;
                        this.validation.maxManifestRecords.hasError = false;
                        this.exportOptions.maxManifestRecords = 0;
                    }
                    if (!this.exportOptions.generateConcordance && !this.exportOptions.generateEdrmXml && !this.exportOptions.exportToDb) {
                        this.extraOptions.includeFullText = false;
                        this.exportOptions.includeFullText = false;
                        this.exportOptions.maximumEmbeddedTextSize = null;
                    }
                    this.markAsDirty();
                    break;
                }
                case 'LST': {
                    this.markAsDirty();
                    break;
                }
                case 'DII': {
                    this.markAsDirty();
                    break;
                }
                case 'CSV': {
                    // exportOptions.generateCsv
                    if (!this.exportOptions.generateConcordance && !this.exportOptions.generateCsv && !this.exportOptions.generateEdrmXml) {
                        this.extraOptions.maxRecordsPerFile = false;
                        this.validation.maxManifestRecords.invalid = false;
                        this.validation.maxManifestRecords.hasError = false;
                        this.exportOptions.maxManifestRecords = 0;
                    }
                    this.markAsDirty();
                    break;
                }
                case 'EDRM XML': {
                    // exportOptions.generateEdrmXml
                    if (!this.exportOptions.generateConcordance && !this.exportOptions.generateCsv && !this.exportOptions.generateEdrmXml) {
                        this.extraOptions.maxRecordsPerFile = false;
                        this.validation.maxManifestRecords.invalid = false;
                        this.validation.maxManifestRecords.hasError = false;
                        this.exportOptions.maxManifestRecords = 0;
                    }
                    if (!this.exportOptions.generateConcordance && !this.exportOptions.generateEdrmXml && !this.exportOptions.exportToDb) {
                        this.extraOptions.includeFullText = false;
                        this.exportOptions.includeFullText = false;
                        this.exportOptions.maximumEmbeddedTextSize = null;
                    }
                    this.markAsDirty();
                    break;
                }
                case 'SQL DB': {
                    if (!this.exportOptions.generateConcordance && !this.exportOptions.generateEdrmXml && !this.exportOptions.exportToDb) {
                        this.extraOptions.includeFullText = false;
                        this.exportOptions.includeFullText = false;
                        this.exportOptions.maximumEmbeddedTextSize = null;
                    }
                    this.validation.tableName.invalid = false;
                    this.validation.tableName.hasError = false;
                    this.tableNameDescriptionComponent.formValid = true;
                    this.exportOptions.tableName = null;
                    this.extraOptions.selectedExportDatabaseConnection = null;
                    this.tableNameDescriptionComponent.name = '';
                    if (this.exportOptions.exportToDb && !this.isExportToRelativity) {
                        this.getExportDatabaseConnection();
                    }
                    break;
                }
            }
            if (this.disabled.noOfOutputFormats() === 6) {
                this.exportOptions.postProcess = false;
                this.exportOptions.postProcessDataAreaHandle = null;
                this.validation.postProcessDataAreaHandle.invalid = false;
                this.exportOptions.includeVolumeLabelInPath = false;
            }
        },
        maxRecordsPerFile: () => {
            if (this.isExportSettingsPage) {
                this.exportOptions.maxRecordsPerFile = this.extraOptions.maxRecordsPerFile;
            }
            if (!this.extraOptions.maxRecordsPerFile) {
                this.validation.maxManifestRecords.invalid = false;
                this.validation.maxManifestRecords.hasError = false;
            }
            if (!this.exportOptions.maxRecordsPerFile) {
                this.exportOptions.maxManifestRecords = 0;
            }
            this.markAsDirty();
        },
        postProcess: () => {
            if (!this.exportOptions.postProcess) {
                this.exportOptions.postProcessDataAreaHandle = null;
                this.validation.postProcessDataAreaHandle.invalid = false;
                this.validation.postProcessDataAreaHandle.hasError = false;
            }
            this.markAsDirty();
        },
        selectedTimezone: () => {
            if (this.exportOptions.timezone === 'Other') {
                this.commonService.openModal(TimezoneModalComponent, { modalData: this.extraOptions.allTimezones }).then((value) => {
                    if (value.modalResult && value.modalData instanceof Timezone) {
                        this.extraOptions.timezones.splice(-1, 1);
                        this.extraOptions.timezones.push(value.modalData);

                        this.extraOptions.timezones.push(new Timezone({
                            description: 'Other...',
                            id: 'Other'
                        }));

                        this.exportOptions.timezone = value.modalData.id;
                        this.extraOptions.prevSelectedTimezone = this.exportOptions.timezone;
                    } else {
                        this.exportOptions.timezone = this.extraOptions.prevSelectedTimezone;
                    }
                });
            } else {
                this.extraOptions.prevSelectedTimezone = this.exportOptions.timezone;
            }
            this.markAsDirty();
        },
        productionSettingType: (optionName: string, onInitialLoadOfExportSettingsPage?: boolean) => {
            switch (optionName) {
                case 'Native': {
                    this.exportOptions.includeNativeFiles = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.exportOptions.includeNativeFiles : !this.exportOptions.includeNativeFiles;
                    this.validation.directory.nativeSubdirectoryInput.name = this.exportOptions.includeNativeFiles ? this.defaultNativeSubdirectoryName ? this.defaultNativeSubdirectoryName : 'NATIVE' : '';
                    this.validation.directory.nativeSubdirectoryInput.invalid = false;
                    this.validation.directory.nativeSubdirectoryInput.hasError = false;
                    this.exportOptions.separateImageExceptions = false;
                    this.exportOptions.emailOutputFormat = this.exportOptions.includeNativeFiles ? this.defaultEmailOutputFormat : null;
                    this.markAsDirty();
                    break;
                }
                case 'Extracted Text': {
                    // exportOptions.includeTextConversion
                    this.exportOptions.includeTextConversion = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.exportOptions.includeTextConversion : !this.exportOptions.includeTextConversion;
                    this.validation.directory.textSubdirectoryInput.name = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.exportOptions.textSubdirectoryName :
                        this.exportOptions.includeTextConversion ? (this.defaultExtractedTextName ? this.defaultExtractedTextName : 'TEXT') : '';
                    this.validation.directory.textSubdirectoryInput.invalid = false;
                    this.validation.directory.textSubdirectoryInput.hasError = false;
                    this.exportOptions.excludeEmailHeaders = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.exportOptions.excludeEmailHeaders : this.exportOptions.includeTextConversion && this.defaultExtractedTextName ? this.defaultExcludeEmailHeaders : false;
                    this.exportOptions.excludeEmailHeadersInLoadFile = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.exportOptions.excludeEmailHeadersInLoadFile : false;
                    this.extraOptions.includeFullText = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.extraOptions.includeFullText : false;
                    this.exportOptions.includeFullText = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.exportOptions.includeFullText : false;
                    this.markAsDirty();
                    break;
                }
                case 'PDF': {
                    // exportOptions.includePdfConversion
                    this.exportOptions.includePdfConversion = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.exportOptions.includePdfConversion : !this.exportOptions.includePdfConversion;
                    this.exportOptions.highlightTerms = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.exportOptions.highlightTerms : this.exportOptions.includePdfConversion ? this.defaultHighlightSearchTermsSelection : false;
                    this.validation.directory.pdfSubdirectoryInput.name = this.isExportSettingsPage && onInitialLoadOfExportSettingsPage ? this.exportOptions.pdfSubdirectoryName : this.exportOptions.includePdfConversion && !this.isReefReviewProject ? 'PDF' : '';
                    this.validation.directory.pdfSubdirectoryInput.invalid = false;
                    this.validation.directory.pdfSubdirectoryInput.hasError = false;
                    if (!this.exportOptions.includeTiffConversion) {
                        if (!this.exportOptions.includePdfConversion) {
                            this.exportOptions.tiffBW = null;
                            this.exportOptions.convertImagesToPdf = this.exportOptions.includePdfConversion && this.defaultGenerateRemainingImagesSelection ? this.defaultGenerateRemainingImagesSelection : false;
                            this.exportOptions.includeStamp = false;
                            this.exportOptions.pageLevelNumbering = false;
                        } else if (this.isExportSettingsPage && this.exportOptions.includePdfConversion) {
                            this.exportOptions.convertImagesToPdf = onInitialLoadOfExportSettingsPage ? this.exportOptions.convertImagesToPdf : this.exportOptions.includePdfConversion ? this.defaultGenerateRemainingImagesSelection : false;
                        } else {
                            this.exportOptions.tiffBW = true;
                            this.exportOptions.convertImagesToPdf = this.exportOptions.includePdfConversion && this.defaultGenerateRemainingImagesSelection ? this.defaultGenerateRemainingImagesSelection : false;
                        }
                    }
                    this.markAsDirty();
                    break;
                }
                case 'TIFF': {
                    // exportOptions.includeTiffConversion
                    this.exportOptions.includeTiffConversion = !this.exportOptions.includeTiffConversion;
                    this.validation.directory.tiffSubdirectoryInput.name = this.isExportSettingsPage ? this.exportOptions.tiffSubdirectoryName : '';
                    this.validation.directory.tiffSubdirectoryInput.invalid = false;
                    this.validation.directory.tiffSubdirectoryInput.hasError = false;
                    this.exportOptions.tiffMode = this.exportOptions.includeTiffConversion ? TiffMode.SINGLE_PAGE : null;

                    if (!this.exportOptions.includePdfConversion) {
                        if (!this.exportOptions.includeTiffConversion) {
                            this.exportOptions.tiffBW = null;
                            this.exportOptions.convertImagesToPdf = false;
                            this.exportOptions.includeStamp = false;
                            this.exportOptions.pageLevelNumbering = false;
                        } else {
                            this.exportOptions.tiffBW = true;
                        }
                    }
                    break;
                }
                case 'Search Terms': {
                    if (this.extraOptions.generateSearchReports) {
                        this.extraOptions.includeMetadata = true;
                    }
                    setTimeout(() => {
                        const searchTermsEl = document.getElementById('searchTerms');
                        if (searchTermsEl) {
                            searchTermsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    });
                    this.markAsDirty();
                    break;
                }
            }
        },
        dateFormat: () => {
            this.validation.dateFormat.check();
            this.markAsDirty();
        },
        dateTimeDelimiter: () => {
            this.validation.dateTimeDelimiter.check();
            this.markAsDirty();
        },
        timeFormat: () => {
            this.validation.timeFormat.check();
            this.markAsDirty();
        },
        duplicateOverlays: () => {
            if (!this.exportOptions.overlayManifest) {
                this.exportOptions.includeAllMasterDuplicates = false;
                this.exportOptions.overlayMetadataTemplateHandle = null;
            } else {
                if (!this.exportOptions.overlayMetadataTemplateHandle) {
                    this.exportOptions.overlayMetadataTemplateHandle = this.extraOptions.exportFieldTemplates.project[0].handle;
                }
            }
        }
    };

    disabled: ExportDisabled = {
        nearDuplicatesProcessAttachments: (): boolean => {
            return !this.exportOptions.includeNearDuplicates || (!this.exportOptions.includeSeperateEmailAttachments && !this.exportOptions.includePdfOLEChildren);
        },
        includeThreadAttach: (): boolean => {
            return !this.exportOptions.includeSeperateEmailAttachments && !this.exportOptions.includePdfOLEChildren;
        },
        maxRecordsPerFile: (): boolean => {
            return !this.exportOptions.generateConcordance && !this.exportOptions.generateCsv && !this.exportOptions.generateEdrmXml;
        },
        includeFullText: (): boolean => {
            return (!this.exportOptions.generateConcordance && !this.exportOptions.generateEdrmXml && !this.exportOptions.exportToDb) || !this.exportOptions.includeTextConversion;
        },
        exportToDb: (): boolean => {
            return (!this.exportOptions.exportToDb || !this.extraOptions.selectedExportDatabaseConnection) && !this.isupdateExportVolume;
        },
        noOfOutputFormats: (): number => {
            let count = 0;
            if (!this.exportOptions.generateConcordance) {
                count++;
            }
            if (!this.exportOptions.generateLst) {
                count++;
            }
            if (!this.exportOptions.generateDii) {
                count++;
            }
            if (!this.exportOptions.generateCsv) {
                count++;
            }
            if (!this.exportOptions.generateEdrmXml) {
                count++;
            }
            if (!this.exportOptions.exportToDb) {
                count++;
            }
            return count;
        },
        pageLevelNumbering: (): boolean => {
            return !this.exportOptions.includePdfConversion && !this.exportOptions.includeTiffConversion;
        },
        tiffBW: (): boolean => {
            return !this.exportOptions.includePdfConversion && !this.exportOptions.includeTiffConversion;
        },
        includeStamp: (): boolean => {
            return !this.exportOptions.includePdfConversion && !this.exportOptions.includeTiffConversion;
        },
        includeTiffConversion: false,
        includePdfConversion: false,
        includeTextConversion: false,
        includeNativeFiles: false
    };

    validation: ExportValidation = {
        drObject: new DrObject(),
        exportStreamName: {
            check: (name: string): void => {
                this.exportStreamNameDescriptionComponent.name = this.extraOptions.exportStreamName = name;
                const exists = this.nameExists(this.exportStreamNameDescriptionComponent.name);
                const empty = DrObject.isEmpty(this.exportStreamNameDescriptionComponent.name);
                this.exportNameNeedsValidation = true;
                this.validation.documentIdPrefix.invalid = false;
                this.validation.exportStreamName.hasError = false;
                this.validation.documentIdPrefix.errorMessage = '';
                this.validation.exportStreamName.checkCharacters(name, exists, empty);
                this.validation.exportStreamName.checkForErrors();
                if (empty) {
                    this.exportStreamNameDescriptionComponent.validateNameError = null;
                    this.validation.exportStreamName.invalid = true;
                    this.validation.exportStreamName.errorType = 'error';
                    this.exportStreamNameDescriptionComponent.validateNameError = `Please specify a Stream name or select an existing \nExport to create a new volume.`;
                    this.validation.exportStreamName.errorMessage = this.exportStreamNameDescriptionComponent.validateNameError;
                    this.validation.exportStreamName.hasError = true;
                }
            },
            checkCharacters: (name: string, exists: boolean, empty: boolean): void => {
                if (!empty && name && name.trim().length) {
                    this.validation.exportStreamName.hasValidCharacters = false;
                    if (!this.nameExists(name)) {
                        this.validation.exportStreamName.isNameValidated = false;
                        this.exportStreamNameDescriptionComponent.onNameChanged();
                        if (this.exportStreamNameDescriptionComponent?.getOriginalName()?.trim()?.toLowerCase() === name?.trim()?.toLowerCase() && this.exportStreamNameDescriptionComponent.getOriginalName() !== '') {
                            this.exportStreamNameDescriptionComponent.formValid = true;
                        }
                        this.setExportNameState(this.exportStreamNameDescriptionComponent.formValid);
                        if (!this.exportStreamNameDescriptionComponent.formValid) {
                            if (this.exportStreamNameDescriptionComponent.validateNameError.includes('Contains one or more')) {
                                const error = this.exportStreamNameDescriptionComponent.validateNameError;
                                this.exportStreamNameDescriptionComponent.validateNameError = error.slice(0, 51) + '\n' + error.slice(52, 115);
                            }
                            this.validation.exportStreamName.errorMessage = this.exportStreamNameDescriptionComponent.validateNameError;
                            this.validation.exportStreamName.hasError = true;
                        }
                    } else {
                        this.validation.exportStreamName.isNameValidated = true;
                    }

                    if (!this.validation.exportStreamName.errorMessage?.includes('Up to')) {
                        this.validation.exportStreamName.errorType = 'error';
                    }
                }
            },
            validateName: (name: string, isItemClick?: boolean): void => {
                if (!DrObject.isEmpty(name) && this.validation.exportStreamName.hasValidCharacters && name !== this.selectedExportStreamClicked) {
                    this.isBusyMessage = `Validating Export Name ...`;
                    this.exportStreamNameDescriptionComponent.validateNameError = null;
                    this.validateName(this.exportStreamNameDescriptionComponent, name, isItemClick);
                    this.selectedExportStreamClicked = name;
                } else if (isItemClick) {
                    this.exportStreamNameDescriptionComponent.validateNameError = null;
                    this.setExportNameState(this.exportStreamNameDescriptionComponent.formValid);
                }
                if (!this.validation.exportStreamName.errorMessage?.includes('Up to')) {
                    this.validation.exportStreamName.errorType = 'error';
                }
                this.exportNameChangedByTyping = false;
                // close the dropdown once the user tab's out of the stream name field
                const streamNamesDropdown = document.getElementById(this.streamNameComboBox.id);
                if (streamNamesDropdown && streamNamesDropdown.classList.contains('show')) {
                    streamNamesDropdown.classList.remove('show');
                }
            },
            checkForErrors: (): void => {
                if (!this.isBusy && this.exportNameNeedsValidation && this.exportStreamNameDescriptionComponent.validateNameError) {
                    this.validation.exportStreamName.errorMessage = this.exportStreamNameDescriptionComponent.validateNameError;
                    this.validation.exportStreamName.invalid = true;
                    this.validation.exportStreamName.hasError = true;
                    if (this.exportStreamNameDescriptionComponent.validateNameError?.includes('Contains')) {
                        this.validation.exportStreamName.checkCharacters(this.extraOptions.exportStreamName);
                    }
                }
            },
            lengthValidation: (): void => {
                this.changeDetector.detectChanges();
                if (this.extraOptions.exportStreamName.length > 100) {
                    this.validation.exportStreamName.invalid = false;
                    this.changeDetector.detectChanges();
                    this.extraOptions.exportStreamName = this.extraOptions.exportStreamName.substring(0, 100);
                    this.validation.exportStreamName.check(this.extraOptions.exportStreamName);
                    this.validation.exportStreamName.errorMessage = 'Up to 100 characters are allowed.' + '\nOne or more characters were trimmed at the end.';
                    this.validation.exportStreamName.errorType = 'info';
                    this.validation.exportStreamName.invalid = true;
                }
            },
            invalid: false,
            hasError: false,
            errorMessage: '',
            errorType: 'error',
            hasValidCharacters: true,
            isNameValidated: true
        },
        tableName: {
            validateName: (): void => {
                if (!this.isBusy && this.tableNameNeedsValidation) {
                    this.validateTableName();
                    this.exportOptions.tableName = this.tableNameDescriptionComponent.name;
                    this.tableNameNeedsValidation = false;
                }
            },
            checkForErrors: (): void => {
                this.tableNameCheckForErrors();
                this.tableNameCheck();
            },
            isDisabled: (): boolean => {
                return this.isTableNameDisabled();
            },
            isCheckboxDisabled: (): boolean => {
                return this.isSQLCheckboxDisabled();
            },
            lengthValidation: (): void => {
                this.changeDetector.detectChanges();
                if (this.exportOptions.tableName.length > 100) {
                    this.validation.tableName.invalid = false;
                    this.changeDetector.detectChanges();
                    this.exportOptions.tableName = this.exportOptions.tableName.substring(0, 100);
                    this.validation.tableName.checkForErrors();
                    this.tableNameDescriptionComponent.validateNameError = 'Up to 100 characters are allowed.' + '\nOne or more characters were trimmed at the end.';
                    this.validation.tableName.errorMessage = this.tableNameDescriptionComponent.validateNameError;
                    this.validation.tableName.invalid = true;
                    this.validation.tableName.errorType = 'info';
                }
            },
            invalid: false,
            hasError: false,
            errorType: 'error',
            errorMessage: '',
            hasValidCharacters: true
        },
        dataAreaHandle: {
            check: (value?: any): void => {
                this.selectedDataAreaName = value;
                this.validation.dataAreaHandle.invalid = !(this.exportOptions.dataAreaHandle) && isNullOrUndefined(this.selectedDataAreaName) && this.selectedDataAreaName !== "";
                this.validation.dataAreaHandle.hasError = !(this.exportOptions.dataAreaHandle) && isNullOrUndefined(this.selectedDataAreaName) && this.selectedDataAreaName !== "";
            },
            invalid: false,
            hasError: false,
            errorMessage: `Please select an Export Data Area.`
        },
        documentFolder: {
            check: (): void => {
                this.validation.documentFolder.invalid = Boolean(!((this.documentFolderPath !== this.DEFAULT_FOLDER_BTN_LABEL || this.exportOptions.createReviewFolder) && (this.isReefReviewProject || this.isRelativityReviewSystem)));
                this.validation.documentFolder.hasError = Boolean(!((this.documentFolderPath !== this.DEFAULT_FOLDER_BTN_LABEL || this.exportOptions.createReviewFolder) && (this.isReefReviewProject || this.isRelativityReviewSystem)));
            },
            errorType: 'error',
            invalid: false,
            hasError: false,
            errorMessage: 'Please select a document folder.'
        },
        documentsToExport: {
            check: (): void => {
                this.validation.documentsToExport.invalid = !this.documentsToExport.query;
                this.validation.documentsToExport.hasError = !this.documentsToExport.query;
            },
            checkForErrors: (): void => {
                if (this.validation.documentsToExport.hasError) {
                    this.validation.documentsToExport.invalid = true;
                }
            },
            invalid: false,
            hasError: false,
            errorMessage: `Please select Documents to Export.`
        },
        nearDuplicatesThreshold: {
            check: (): void => {
                this.validation.nearDuplicatesThreshold.invalid = this.exportOptions.includeNearDuplicates && !isNumber(this.exportOptions.nearDuplicatesThreshold);
                this.validation.nearDuplicatesThreshold.hasError = this.exportOptions.includeNearDuplicates && !isNumber(this.exportOptions.nearDuplicatesThreshold);
            },
            invalid: false,
            hasError: false,
            errorMessage: `Please specify Threshold.`
        },
        nearDuplicatesMinTermCount: {
            check: (): void => {
                this.validation.nearDuplicatesMinTermCount.invalid = this.exportOptions.includeNearDuplicates && !isNumber(this.exportOptions.nearDuplicatesMinTermCount);
                this.validation.nearDuplicatesMinTermCount.hasError = this.exportOptions.includeNearDuplicates && !isNumber(this.exportOptions.nearDuplicatesMinTermCount);
            },
            invalid: false,
            hasError: false,
            errorMessage: `Please specify Minimum Terms.`
        },
        dateFormat: {
            check: (): void => {
                this.validation.dateFormat.invalid = this.validation.dateFormat.hasError = !(this.exportOptions.dateFormat);
                this.markAsDirty();
            },
            checkForErrors: (): void => {
                if (this.validation.dateFormat.invalid) {
                    this.validation.dateFormat.check();
                }
                this.markAsDirty();
            },
            invalid: false,
            errorMessage: `Please specify a Date Format.`,
            hasError: false
        },
        dateTimeDelimiter: {
            check: (): void => {
                this.validation.dateTimeDelimiter.invalid = this.validation.dateTimeDelimiter.hasError = !(this.exportOptions.dateTimeDelimiter);
            },
            checkForErrors: (): void => {
                if (this.validation.dateTimeDelimiter.invalid) {
                    this.validation.dateTimeDelimiter.check();
                }
            },
            invalid: false,
            errorMessage: `Please specify a Delimiter.`,
            hasError: false
        },
        timeFormat: {
            check: (): void => {
                this.validation.timeFormat.invalid = this.validation.timeFormat.hasError = !(this.exportOptions.timeFormat);
                this.markAsDirty();
            },
            checkForErrors: (): void => {
                if (this.validation.timeFormat.invalid) {
                    this.validation.timeFormat.check();
                }
                this.markAsDirty();
            },
            invalid: false,
            errorMessage: `Please specify a Time Format.`,
            hasError: false
        },
        maxManifestRecords: {
            check: (): void => {
                this.validation.maxManifestRecords.invalid = this.extraOptions.maxRecordsPerFile && !isNumber(this.exportOptions.maxManifestRecords);
                this.validation.maxManifestRecords.hasError = this.extraOptions.maxRecordsPerFile && !isNumber(this.exportOptions.maxManifestRecords);
                this.markAsDirty();
            },
            checkForErrors: (): void => {
                if (this.validation.maxManifestRecords.hasError) {
                    this.validation.maxManifestRecords.invalid = true;
                }
                this.markAsDirty();
            },
            invalid: false,
            hasError: false,
            errorMessage: `Please specify Max Records Per File.`
        },
        postProcessDataAreaHandle: {
            check: (): void => {
                this.validation.postProcessDataAreaHandle.invalid = this.isExportSettingsPage ? false : this.exportOptions.postProcess && !(this.exportOptions.postProcessDataAreaHandle);
                this.validation.postProcessDataAreaHandle.hasError = this.isExportSettingsPage ? false : this.exportOptions.postProcess && !(this.exportOptions.postProcessDataAreaHandle);
            },
            invalid: false,
            hasError: false,
            errorMessage: `Please select a Data Area for encrypted files.`
        },
        volumeLabel: {
            check: (): void => {
                if (this.exportOptions.volumeLabel) {
                    this.validation.drObject.regex = SupportedRegExType.CONNECTOR;
                    const errorMessage = this.validation.drObject.uiValidateName(this.exportOptions.volumeLabel);
                    this.validation.drObject.regex = SupportedRegExType.GENERIC;
                    if (errorMessage) {
                        this.validation.volumeLabel.errorMessage = errorMessage;
                        this.validation.volumeLabel.invalid = true;
                        this.validation.volumeLabel.hasError = true;
                    } else if (!this.validation.volumeLabel.errorMessage?.includes('Up to')) {
                        this.validation.volumeLabel.invalid = false;
                        this.validation.volumeLabel.hasError = false;
                    }
                    this.volumeLabelFromOptions = this.exportOptions.volumeLabel;
                } else {
                    this.validation.volumeLabel.invalid = true;
                    this.validation.volumeLabel.hasError = true;
                    this.validation.volumeLabel.errorMessage = `Please specify Volume Label.`
                }
                if (!this.validation.volumeLabel.errorMessage?.includes('Up to')) {
                    this.validation.volumeLabel.errorType = 'error';
                }
                this.markAsDirty();
            },
            lengthValidation: (): void => {
                this.changeDetector.detectChanges();
                if (this.exportOptions.volumeLabel.length > 50) {
                    this.validation.volumeLabel.invalid = false;
                    this.changeDetector.detectChanges();
                    this.exportOptions.volumeLabel = this.exportOptions.volumeLabel.substring(0, 50);
                    this.validation.volumeLabel.check();
                    this.validation.volumeLabel.errorMessage = this.warningMessage;
                    this.validation.volumeLabel.errorType = 'info';
                    this.validation.volumeLabel.invalid = true;
                }
                this.markAsDirty();
            },
            hasError: false,
            invalid: false,
            errorMessage: '',
            errorType: 'error'
        },
        documentIdPrefix: {
            check: (id: string): void => {
                this.prefixString = id !== undefined ? id : this.exportOptions.documentIdPrefix;
                if (this.prefixString) {
                    this.validation.drObject.regex = SupportedRegExType.CONNECTOR;
                    let errorMessage = this.validation.drObject.uiValidateName(this.prefixString);
                    this.validation.drObject.regex = SupportedRegExType.GENERIC;
                    if (errorMessage) {
                        if (errorMessage.includes('invalid characters')) {
                            errorMessage = 'Contains a space or one or more of these invalid\ncharacters: ! " \' # $ % & * + / : ; < = > ? @ [ \\ ] ^ { | } ~ \u201c \u201d';
                        }
                        this.validation.documentIdPrefix.errorMessage = errorMessage;
                        this.validation.documentIdPrefix.invalid = true;
                        this.validation.documentIdPrefix.hasError = true;
                    } else if (!this.validation.documentIdPrefix.errorMessage?.includes('Up to')) {
                        this.validation.documentIdPrefix.invalid = false;
                        this.validation.documentIdPrefix.hasError = false;
                    }
                } else {
                    this.validation.documentIdPrefix.invalid = true;
                    this.validation.documentIdPrefix.hasError = true;
                    this.validation.documentIdPrefix.errorMessage = `Please specify ID Prefix.`
                }
                if (!this.validation.documentIdPrefix.errorMessage?.includes('Up to')) {
                    this.validation.documentIdPrefix.errorType = 'error';
                }
                this.markAsDirty();
            },
            lengthValidation: (): void => {
                this.changeDetector.detectChanges();
                if (this.exportOptions.documentIdPrefix.length > 50) {
                    this.validation.documentIdPrefix.invalid = false;
                    this.changeDetector.detectChanges();
                    this.exportOptions.documentIdPrefix = this.exportOptions.documentIdPrefix.substring(0, 50);
                    this.validation.documentIdPrefix.check();
                    this.validation.documentIdPrefix.errorMessage = 'Up to 50 characters are allowed.\nOne or more characters were trimmed at the end.';
                    this.validation.documentIdPrefix.errorType = 'info';
                    this.validation.documentIdPrefix.invalid = true;
                }
                this.markAsDirty();
            },
            invalid: false,
            errorMessage: '',
            hasError: false,
            errorType: 'error'
        },
        basePath: {
            check: (): void => {
                if (this.exportOptions.basePath) {
                    this.validation.drObject.regex = SupportedRegExType.CONNECTOR;
                    const errorMessage = this.validation.drObject.uiValidateName(this.exportOptions.basePath);
                    this.validation.drObject.regex = SupportedRegExType.GENERIC;
                    if (errorMessage) {
                        this.validation.basePath.errorMessage = errorMessage;
                        this.validation.basePath.invalid = true;
                        this.validation.basePath.hasError = true;
                    } else if (!this.validation.basePath.errorMessage?.includes('Up to')) {
                        this.validation.basePath.invalid = false;
                        this.validation.basePath.hasError = false;
                    }
                } else {
                    this.validation.basePath.invalid = false;
                    this.validation.basePath.hasError = false;
                }
                if (!this.validation.basePath.errorMessage?.includes('Up to')) {
                    this.validation.basePath.errorType = 'error';
                }
                this.markAsDirty();
            },
            lengthValidation: (): void => {
                this.changeDetector.detectChanges();
                if ((this.exportOptions.basePath?.length ?? 0) > 50) {
                    // Reset invalid to force false→true transition so the popover
                    // re-shows even after X dismiss or when invalid was already true
                    this.validation.basePath.invalid = false;
                    this.changeDetector.detectChanges();
                    this.exportOptions.basePath = this.exportOptions.basePath.substring(0, 50);
                    this.validation.basePath.check();
                    this.validation.basePath.errorMessage = this.warningMessage;
                    this.validation.basePath.errorType = 'info';
                    this.validation.basePath.invalid = true;
                } else if (this.validation.basePath.errorMessage?.includes('Up to')) {
                    this.validation.basePath.errorMessage = null;
                }
                this.markAsDirty();
            },
            hasError: false,
            invalid: false,
            errorMessage: '',
            errorType: 'error'
        },
        startingDocumentId: {
            defaultStartingDocumentId: 1,
            check: (event): void => {
                this.changeDetector.detectChanges();
                this.validation.startingDocumentId.invalid = false;
                if (event) {
                    if (isNullOrUndefined(this.extraOptions.startingDocumentIdDisplay)) {
                        this.validation.startingDocumentId.invalid = true;
                        this.validation.startingDocumentId.isFieldEmptyOnBlur = true;
                    } else {
                        this.validation.startingDocumentId.isFieldEmptyOnBlur = false;
                    }
                }
                if (!this.extraOptions.startingDocumentIdDisplay || (!this.isNewIdPrefix && parseInt(this.extraOptions.startingDocumentIdDisplay, 10) < parseInt(this.selectedId, 10))) {
                    let defDocId = this.selectedId;
                    if (defDocId.length > this.exportOptions.documentIdPadSize) {
                        defDocId = defDocId.substr(0, this.exportOptions.documentIdPadSize);
                    } else {
                        defDocId = defDocId.padStart(this.exportOptions.documentIdPadSize, '0');
                    }
                    this.validation.startingDocumentId.errorMessage = `The Starting ID value entered must be greater or equal to \n${defDocId}.` +
                        ` The value has been reset to ${defDocId}.`;
                    this.validation.startingDocumentId.hasError = true;
                    this.exportOptions.startingDocumentId = this.validation.startingDocumentId.defaultStartingDocumentId;
                    this.exportOptions.updatedStartingDocumentId = this.validation.startingDocumentId.defaultStartingDocumentId;
                    this.extraOptions.startingDocumentIdDisplay = this.selectedId;
                    this.validation.startingDocumentId.parse();
                    this.validation.startingDocumentId.invalid = false;
                }
                if (this.validation.startingDocumentId.invalid && this.extraOptions.startingDocumentIdDisplay < this.validation.startingDocumentId.defaultStartingDocumentId.toString()) {
                    this.extraOptions.startingDocumentIdDisplay = this.validation.startingDocumentId.defaultStartingDocumentId.toString();
                    this.validation.startingDocumentId.parse();
                }
                this.markAsDirty();
            },
            parse: (): void => {
                this.documentIdPadSize = this.exportOptions.documentIdPadSize;
                let val = parseInt(this.extraOptions.startingDocumentIdDisplay, 10);
                if (isNaN(val)) {
                    val = 1;
                }
                this.extraOptions.startingDocumentIdDisplay = val.toString();
                if (this.extraOptions.startingDocumentIdDisplay.length > this.exportOptions.documentIdPadSize) {
                    this.extraOptions.startingDocumentIdDisplay = this.extraOptions.startingDocumentIdDisplay.substr(0, this.exportOptions.documentIdPadSize);
                } else {
                    this.extraOptions.startingDocumentIdDisplay = this.extraOptions.startingDocumentIdDisplay.padStart(this.exportOptions.documentIdPadSize, '0');
                }
                this.exportOptions.startingDocumentId = parseInt(this.extraOptions.startingDocumentIdDisplay, 10);
                this.markAsDirty();
            },
            checkForErrors: (): void => {
                if (!isNullOrUndefined(this.extraOptions.startingDocumentIdDisplay)) {
                    this.validation.startingDocumentId.invalid = false;
                    this.validation.startingDocumentId.isFieldEmptyOnBlur = false;
                } else {
                    this.validation.startingDocumentId.invalid = true;
                    this.validation.startingDocumentId.isFieldEmptyOnBlur = true;
                }
                this.markAsDirty();
            },
            invalid: false,
            errorMessage: `Please specify Starting ID.`,
            hasError: false,
            isFieldEmptyOnBlur: false
        },
        directory: {
            nativeSubdirectoryInput: new ExportInputName(this.changeDetector, { errorType: 'error', maxChar: 50 }, () => {
                this.exportOptions.nativeSubdirectoryName = this.validation.directory.nativeSubdirectoryInput.name || null;
                this.markAsDirty();
            }),
            textSubdirectoryInput: new ExportInputName(this.changeDetector, { errorType: 'error', maxChar: 50 }, () => {
                this.exportOptions.textSubdirectoryName = this.validation.directory.textSubdirectoryInput.name || null;
                this.markAsDirty();
            }),
            pdfSubdirectoryInput: new ExportInputName(this.changeDetector, { errorType: 'error', maxChar: 50 }, () => {
                this.exportOptions.pdfSubdirectoryName = this.validation.directory.pdfSubdirectoryInput.name || null;
                this.markAsDirty();
            }),
            tiffSubdirectoryInput: new ExportInputName(this.changeDetector, { errorType: 'error', maxChar: 50 }),
        },
        reviewProjectId: {
            check: (event): void => {
                this.validation.reviewProjectId.invalid = !(this.exportOptions.reviewProjectId);
                this.validation.reviewProjectId.hasError = !(this.exportOptions.reviewProjectId);
                if (event) {
                    //review proj id has changed => cleanup the selected review folder info
                    this.selectedFolderPath = this.DEFAULT_FOLDER_BTN_LABEL;
                    this.documentFolderPath = this.DEFAULT_FOLDER_BTN_LABEL;
                    this.isFolderPathSelected = false;
                    this.exportOptions.reviewFolderPath = '';
                    this.exportOptions.reviewFolderId = -1;
                    this.exportOptions.reviewFolderName = '';
                    if (this.isReefReviewWithConnector && this.exportOptions.reviewProjectId) {
                        this.loadExportDataAreas(false);
                    }
                }
            },
            invalid: false,
            hasError: false,
            errorMessage: 'Please select a Review Project.'
        },
        valid: (): boolean => {
            let invalid = false;

            if (!this.isExportSettingsPage) {
                this.validation.exportStreamName.check(this.extraOptions.exportStreamName);
                invalid = this.validation.exportStreamName.invalid || this.checkExportNameOnRun();
                    this.validation.dataAreaHandle.check();
                invalid = invalid || this.validation.dataAreaHandle.invalid;
                this.validation.documentsToExport.check();
                invalid = invalid || this.validation.documentsToExport.invalid;

                if (this.currentReviewSystem !== ReviewSystem.NONE && !this.optionsDisabled) {
                    this.validation.documentFolder.check();
                    invalid = invalid || this.validation.documentFolder.invalid;
                    this.validation.reviewProjectId.check();
                    invalid = invalid || this.validation.reviewProjectId.invalid;
                }
            }
            this.validation.nearDuplicatesThreshold.check();
            invalid = invalid || this.validation.nearDuplicatesThreshold.invalid;
            this.validation.nearDuplicatesMinTermCount.check();
            invalid = invalid || this.validation.nearDuplicatesMinTermCount.invalid;
            this.validation.dateFormat.check();
            invalid = invalid || this.validation.dateFormat.invalid;
            this.validation.dateTimeDelimiter.check();
            invalid = invalid || this.validation.dateTimeDelimiter.invalid;
            this.validation.timeFormat.check();
            invalid = invalid || this.validation.timeFormat.invalid;
            this.validation.maxManifestRecords.check();
            invalid = invalid || this.validation.maxManifestRecords.invalid;
            this.validation.postProcessDataAreaHandle.check();
            invalid = invalid || this.validation.postProcessDataAreaHandle.invalid;
            this.validation.volumeLabel.check();
            invalid = invalid || this.validation.volumeLabel.hasError;
            this.validation.documentIdPrefix.check(this.prefixString);
            invalid = invalid || this.validation.documentIdPrefix.hasError;
            this.validation.startingDocumentId.check();
            invalid = invalid || this.validation.startingDocumentId.invalid || this.validation.startingDocumentId.isFieldEmptyOnBlur;
            this.validation.directory.nativeSubdirectoryInput.check();
            invalid = invalid || this.validation.directory.nativeSubdirectoryInput.hasError;
            this.validation.directory.textSubdirectoryInput.check();
            invalid = invalid || this.validation.directory.textSubdirectoryInput.hasError;
            this.validation.directory.pdfSubdirectoryInput.check();
            invalid = invalid || this.validation.directory.pdfSubdirectoryInput.hasError;
            this.validation.directory.tiffSubdirectoryInput.check();
            invalid = invalid || this.validation.directory.tiffSubdirectoryInput.hasError;
            this.validation.basePath.check();
            invalid = invalid || this.validation.basePath.hasError;

            if (!this.disabled.exportToDb()) {
                this.validation.tableName.checkForErrors();
                invalid = invalid || this.validation.tableName.invalid;
            }
            this.changeDetector.detectChanges();
            return !invalid;
        }
    };

    documentsToExport: ExportDocumentsToExport = {
        searchWrapper: new SearchWrapper(new SearchConfig({ searchDialect: this.commonService.searchDialect, simpleParsingNoCookies: true, isSimpleSearch: false })),
        allDocs: false,
        allDocsDisabled: false,
        allDocsChanged: () => {
            this.documentsToExport.query = this.documentsToExport.allDocs ? 'ALLDOCS' : '';
            this.documentsToExport.queryChanged();
            this.documentsToExport.selectTagsDisabled = this.documentsToExport.allDocs;
        },
        selectTags: () => {
            const data = {
                entityType: 'tags',
                filterType: 'allTags',
                items: this.documentsToExport.selectedTags.map(t => t.name)
            };
            this.commonService.openModal(GenericPickerModalComponent, { modalData: data, class: 'vertical-percent-50' }).then(response => {
                if (response && response.modalResult && response.modalData) {
                    this.documentsToExport.allDocsDisabled = true;
                    this.documentsToExport.selectedTags = response.modalData as Array<Tag>;
                    this.documentsToExport.query = this.documentsToExport.selectedTags.map(t => `tag_view::"${t.name}"`).join(' OR ');
                    this.documentsToExport.queryChanged();
                }
            });
        },
        selectedTags: new Array<Tag>(),
        selectTagsDisabled: false,
        query: '',
        queryChanged: () => {
            if (this.documentsToExport.query) {
                if (this.validation.documentsToExport.invalid) {
                    this.validation.documentsToExport.invalid = false;
                    this.validation.documentsToExport.hasError = false;
                }
                this.documentsToExport.searchWrapper.keywords.value = this.documentsToExport.query;
                this.exportOptions.documentsToExport = this.xmlService.objectToXMLQuery(this.documentsToExport.searchWrapper);
                this.validation.documentsToExport.hasError = false;
            } else {
                this.exportOptions.documentsToExport = null;
                this.validation.documentsToExport.invalid = true;
                this.validation.documentsToExport.hasError = true;
            }
        },
        clearQuery: () => {
            this.documentsToExport.query = '';
            this.documentsToExport.queryChanged();
            this.documentsToExport.allDocs = false;
            this.documentsToExport.selectedTags.length = 0;
            this.documentsToExport.allDocsDisabled = false;
            this.documentsToExport.selectTagsDisabled = false;
        }
    };

    stamping: ExportStamping = {
        init: () => {
            const stampPositions = this.commonService.getEnumNames(StampPosition);
            stampPositions.forEach(stampPosition => {
                if (!this.exportOptions[`stamp${stampPosition}Type`] || this.exportOptions[`stamp${stampPosition}Type`] === StampType.NONE) {
                    delete this.exportOptions[`stamp${stampPosition}Type`];
                    delete this.exportOptions[`stamp${stampPosition}Line`];
                    delete this.exportOptions[`stamp${stampPosition}Value`];
                }
                this.stamping[stampPosition] = new ProductionStamp({
                    position: <StampPosition>stampPosition,
                    stampType: this.exportOptions[`stamp${stampPosition}Type`],
                    stampLine: this.exportOptions[`stamp${stampPosition}Line`],
                    stampValue: this.exportOptions[`stamp${stampPosition}Value`]
                });
            });
        },
        getStampClasses: (selectedStamp: ProductionStamp, selectedLine: number) => {
            if (selectedStamp && selectedLine) {
                let classes = '';
                if (selectedStamp.stampType) {
                    if (selectedStamp.stampLine === selectedLine) {
                        classes = 'stamp-cell-available stamp-cell-value';
                        if (this.optionsDisabled) {
                            classes += ' stamp-cell-value-disabled';
                        }
                    } else {
                        return 'stamp-cell-not-available';
                    }
                } else {
                    classes = 'stamp-cell-available';
                }
                if (selectedStamp === this.stamping.selectedStamp && this.stamping.selectedStamp.stampLineEdit === selectedLine) {
                    classes += ' stamp-cell-selected';
                }
                return classes;
            }
        },
        clear: (selectedStamp: ProductionStamp, event: MouseEvent) => {
            if (selectedStamp) {
                this.stamping.selectedStamp = selectedStamp;
                this.stamping.selectedStamp.stampTypeEdit = StampType.NONE;
                this.stamping.save();
            }
            if (event) {
                event.stopPropagation();
            }
        },
        edit: (selectedStamp: ProductionStamp, selectedLine: number) => {
            if (selectedStamp && selectedLine && (!selectedStamp.stampType || selectedStamp.stampLine === selectedLine)) {
                selectedStamp.stampLineEdit = selectedLine;
                this.stamping.selectedStamp = selectedStamp;
            }
        },
        save: () => {
            if (this.stamping.selectedStamp) {
                if (this.stamping.selectedStamp.stampTypeEdit === StampType.NONE) {
                    delete this.exportOptions[this.stamping.selectedStamp.stampTypeAttribute];
                    delete this.exportOptions[this.stamping.selectedStamp.stampLineAttribute];
                    delete this.exportOptions[this.stamping.selectedStamp.stampValueAttribute];
                } else {
                    this.exportOptions[this.stamping.selectedStamp.stampTypeAttribute] = this.stamping.selectedStamp.stampTypeEdit;
                    this.exportOptions[this.stamping.selectedStamp.stampLineAttribute] = this.stamping.selectedStamp.stampLineEdit;
                    this.exportOptions[this.stamping.selectedStamp.stampValueAttribute] = this.stamping.selectedStamp.stampValueEdit;
                }
                this.stamping.selectedStamp.stampType = this.exportOptions[this.stamping.selectedStamp.stampTypeAttribute];
                this.stamping.selectedStamp.stampLine = this.exportOptions[this.stamping.selectedStamp.stampLineAttribute];
                this.stamping.selectedStamp.stampValue = this.exportOptions[this.stamping.selectedStamp.stampValueAttribute];
            }
            this.stamping.cancel();
        },
        cancel: () => {
            if (this.stamping.selectedStamp) {
                this.stamping.selectedStamp.stampTypeEdit = null;
                this.stamping.selectedStamp.stampLineEdit = null;
                this.stamping.selectedStamp.stampValueEdit = null;
            }
            this.stamping.selectedStamp = null;
        }
    };

    checkExportNameOnRun(): boolean {
        return this.fieldInFocus;
    }

    constructor(private commonService: CommonService, private restService: RestService, private xmlService: XMLService, private changeDetector: ChangeDetectorRef) {
        this.exportOptions = new ExportStreamOptions();
        this.handleExportOptions(this.exportOptions);
    }

    initializeNameDescriptionComponent(nameDescriptionComponent: NameDescriptionComponent, viewModel: DrObject) {
        nameDescriptionComponent.name = '';
        nameDescriptionComponent.drObject = viewModel;
        nameDescriptionComponent.initialize();
        nameDescriptionComponent.isDescriptionDisabled = true;
        nameDescriptionComponent.disableErrorPopover = false;
        nameDescriptionComponent.validateName = true;
        nameDescriptionComponent.validateNameRequest = {
            endpoint: Endpoint.viewManager_validateName,
            request: (name) => {
                return {
                    name: name,
                    projectHandle: this.commonService.currentProject?.handle,
                    objectType: nameDescriptionComponent.drObject.objectType
                };
            }
        };
    }

    initializeExportStreamNameDescriptionComponent() {
        this.validation.exportStreamName.hasValidCharacters = false;
        this.exportStreamNameDescriptionComponent = new NameDescriptionComponent(this.restService);
        this.initializeNameDescriptionComponent(this.exportStreamNameDescriptionComponent, this.exportStreamViewModel);
        if (this.selectedExportStream && this.selectedExportStream.name) {
            this.exportStreamNameDescriptionComponent.name = this.selectedExportStream.name;
        }
        this.setNameDescriptionComponentName(this.exportStreamNameDescriptionComponent);
    }

    initializeTableNameDescriptionComponent() {
        this.validation.tableName.hasValidCharacters = false;
        this.tableNameDescriptionComponent = new NameDescriptionComponent(this.restService);
        this.initializeNameDescriptionComponent(this.tableNameDescriptionComponent, this.exportDatabaseTableViewModel);
        if (this.exportOptions && this.exportOptions.tableName) {
            this.tableNameDescriptionComponent.name = this.exportOptions.tableName;
        }
        this.setNameDescriptionComponentName(this.tableNameDescriptionComponent);
    }

    ngOnInit(): void {
        if (this.isExportSettingsPage) {
            this.currentReviewSystem = ReviewSystem.NONE;
            this.exportOptions = this.exportSettingsOptions;
            this.handleExportOptions(this.exportOptions, true);
        } else {
            if (this.selectedExportStream) {              
                this.setReviewSystemFromOptions(this.selectedExportStream.options?.reviewSystem);
                if (this.currentReviewSystem !== ReviewSystem.NONE) {
                    this.getReviewProjectsAttachedToCurrentProject();
                }
            } else {
                if (isNullOrUndefined(this.commonService.currentProject.reviewSystem)) {
                    this.currentReviewSystem = ReviewSystem.NONE;
                } else {
                    // check to see if the system is a reefreview system
                    if (this.commonService.currentProject?.reviewProjectId !== 0 && this.commonService.currentProject?.reviewSystem === ReviewSystem.REEF_REVIEW) {
                        this.isReefReviewProject = this.commonService.isDRExportEnabled() ? false : true;
                        this.onChange.productionSettingType('Extracted Text');
                    }
                    if (this.commonService.currentProject?.reviewSystem === ReviewSystem.RELATIVITY) {
                        this.isRelativityReviewSystem = true;
                    }
                    this.getReviewProjectsAttachedToCurrentProject();
                    this.setCurrentReviewSystemForExportForm();
                }
            }
        }
        if (this.isExportToRelativity) {
            this.exportOptions.highlightTerms = true;
            this.exportOptions.convertImagesToPdf = this.commonService.currentProject?.tlsDefaultExportStream.options.convertImagesToPdf;
            this.exportOptions.pdfSubdirectoryName = this.commonService.currentProject?.tlsDefaultExportStream.options.pdfSubdirectoryName;
            this.exportOptions.includePdfConversion = true;
            this.exportOptions.custodianReportQueries = this.commonService.currentProject?.tlsDefaultExportStream.options.custodianReportQueries;
            this.setExportOptions(this.exportOptions);
        }
        this.isSystemUserWithPermissions = (this.commonService.currentUser?.importedFromSystemUser || this.commonService.currentUser?.originalCustomerName === 'super_system_customer') && Permissions.checkUserPermission(ObjectActionListType.SYSTEM_EXPORT_FIELDS, ActionType.VIEW);
        if (!this.isupdateExportVolume) {
            this.loadData();
        } else {
            this.exportOptions = this.exportOptionsFromUpdateExportVolume;
            this.setExportOptions(this.exportOptions);
        }
        this.setDBTableStates();
        this.loadFolderByOptions();
    }

    setCurrentReviewSystemForExportForm(): void {
        if (this.isReefReviewProject) {
            this.currentReviewSystem = ReviewSystem.REEF_REVIEW;
        } else if (this.isRelativityReviewSystem) {
            this.currentReviewSystem = ReviewSystem.RELATIVITY;
            this.exportOptions.generateCsv = true;
        } 
    }

    onChangeReviewSystem(selectedReviewSystem: ReviewSystem): void {
        this.currentReviewSystem = selectedReviewSystem;
        if (this.currentReviewSystem === ReviewSystem.RELATIVITY && !this.exportOptions.generateCsv) {
            this.exportOptions.generateCsv = true;
        } else {
            this.exportOptions.generateCsv = false;
        }
    }

    getReviewProjectsAttachedToCurrentProject() {
        if (this.commonService.currentProject?.reviewProjects?.length > 0) {
            this.availableReviewProjects = this.commonService.currentProject?.reviewProjects;

            if (this.availableReviewProjects?.length === 1 && this.commonService.currentProject?.reviewProjectId === this.availableReviewProjects[0].reviewProjectId) {
                this.exportOptions.reviewProjectId = this.availableReviewProjects[0].reviewProjectId;
            }
        }
    }

    setReviewSystemFromOptions(reviewSystem: string) {
        if (reviewSystem === '' || !reviewSystem) {
            this.currentReviewSystem = ReviewSystem.NONE;
        } else {
            this.currentReviewSystem = reviewSystem as ReviewSystem;
        }
        switch (this.currentReviewSystem) {
            case ReviewSystem.RELATIVITY:
                this.isRelativityReviewSystem = true;
                break;
            case ReviewSystem.REEF_REVIEW:
                this.isReefReviewProject = true;
                break;
            case ReviewSystem.NONE: 
                this.isReefReviewProject = false;
                this.isRelativityReviewSystem = false;
                break;
        }
    }

    handleExportOptions(exportOptions: ExportStreamOptions, isExportSettingsPage?: boolean, triggerChangeDetection?: boolean) {
        if (!exportOptions) {
            return;
        }
        this.exportOptions = exportOptions;

        const emailOptions = this.isExportSettingsPage ? exportOptions.emailOptions : EmailOptions.INCLUDE_MAGS;
        const generateConcordance = this.isExportSettingsPage ? exportOptions.generateConcordance : true;
        const begAttachMode = this.isExportSettingsPage ? exportOptions.begAttachMode : BegAttachMode.PARENT_EMAIL;
        const dateFormat = this.isExportSettingsPage && exportOptions.dateFormat ? exportOptions.dateFormat : this.extraOptions.dateFormats[0];
        const dateTimeDelimiter = this.isExportSettingsPage && exportOptions.dateTimeDelimiter ? exportOptions.dateTimeDelimiter : this.extraOptions.delimiters[2];
        const timeFormat = this.isExportSettingsPage && exportOptions.timeFormat ? exportOptions.timeFormat : this.extraOptions.timeFormats[0];
        const manifestSizeUnits = this.isExportSettingsPage && exportOptions.manifestSizeUnits ? exportOptions.manifestSizeUnits : SizeUnits.BYTES;
        // Family / Thread Options
        this.onChange.emailOptions(emailOptions);
        // Duplicates Processing
        exportOptions.exportDuplicateMode = this.isExportSettingsPage ? exportOptions.exportDuplicateMode : this.isReefReviewProject ? ExportDuplicateMode.UNIQUE_DOCUMENTS : ExportDuplicateMode.ALL_DOCUMENT_REFERENCES;
        // Duplicates Processing
        exportOptions.generateConcordance = generateConcordance;
        if (!isExportSettingsPage) {
            this.onChange.outputOptions('DAT');
        }
        exportOptions.begAttachMode = begAttachMode;
        this.exportOptions.dateFormat = dateFormat;
        this.exportOptions.dateTimeDelimiter = (dateTimeDelimiter === ' ' || dateTimeDelimiter === " " || dateTimeDelimiter === 'Space') ? 'Space' : dateTimeDelimiter;
        this.exportOptions.timeFormat = timeFormat;
        exportOptions.manifestSizeUnits = manifestSizeUnits;
        //Output Options
        exportOptions.overlayMetadataTemplateHandle = this.isExportSettingsPage ? exportOptions.overlayMetadataTemplateHandle : null;
        this.exportOptions.overlayManifest = exportOptions.overlayManifest;
        // Formatting Settings 
        exportOptions.concordanceUnicodeFormat = this.isExportSettingsPage ? exportOptions.concordanceUnicodeFormat : false;
        // Production Settings
        exportOptions.basePath = this.isExportSettingsPage ? exportOptions.basePath : 'DR';
        exportOptions.volumeLabel = this.isExportSettingsPage ? exportOptions.volumeLabel : 'VOL';
        exportOptions.documentIdPrefix = this.isExportSettingsPage ? exportOptions.documentIdPrefix : this.extraOptions.documentPrefixes[0];
        // Clear validation states and sync prefixString when values are restored
        this.prefixString = exportOptions.documentIdPrefix;
        this.validation.documentIdPrefix.invalid = false;
        this.validation.documentIdPrefix.hasError = false;
        this.validation.basePath.invalid = false;
        this.validation.basePath.hasError = false;
        this.validation.volumeLabel.invalid = false;
        this.validation.volumeLabel.hasError = false;
        exportOptions.startingDocumentId = this.isExportSettingsPage ? exportOptions.startingDocumentId : this.validation.startingDocumentId.defaultStartingDocumentId = 1;
        // Clear all startingDocumentId validation states
        this.validation.startingDocumentId.invalid = false;
        this.validation.startingDocumentId.hasError = false;
        this.validation.startingDocumentId.isFieldEmptyOnBlur = false;
        this.validation.startingDocumentId.defaultStartingDocumentId = this.exportOptions.startingDocumentId;
        this.extraOptions.startingDocumentIdDisplay = this.validation.startingDocumentId.defaultStartingDocumentId.toString();
        this.selectedId = this.extraOptions.startingDocumentIdDisplay;
        if (triggerChangeDetection) {
            this.changeDetector.detectChanges();
        }
        this.validation.startingDocumentId.parse();
        exportOptions.pageSeperator = this.isExportSettingsPage ? exportOptions.pageSeperator : '_';
        exportOptions.documentIdPadSize = this.isExportSettingsPage ? exportOptions.documentIdPadSize : 10;
        exportOptions.pagePadSize = this.isExportSettingsPage ? exportOptions.pagePadSize : 4;
        this.isHyland = this.commonService.externalParsingLibrary === 'OIT' ? false : true;

        exportOptions.stampFontName = this.isExportSettingsPage ? exportOptions.stampFontName : 'Unifont';
        exportOptions.stampFontSize = this.isExportSettingsPage ? exportOptions.stampFontSize : 10;
        exportOptions.stampBottomRightLine = this.isExportSettingsPage ? exportOptions.stampBottomRightLine : 1;
        exportOptions.stampBottomRightType = this.isExportSettingsPage ? exportOptions.stampBottomRightType : StampType.BATES;
        this.stamping.init();

        this.focusFieldEvent = this.commonService.getMessage(MessageType.fieldInFocus).subscribe((data) => {
            this.fieldInFocus = data;
        });

        if (isExportSettingsPage) {
            this.currentReviewSystem = ReviewSystem.NONE;
            // Convert threshold from decimal (0.8) to percentage (80) for display
            if (exportOptions.nearDuplicatesThreshold && exportOptions.nearDuplicatesThreshold < 1) {
                exportOptions.nearDuplicatesThreshold = exportOptions.nearDuplicatesThreshold * 100;
            } else if (!exportOptions.nearDuplicatesThreshold) {
                exportOptions.nearDuplicatesThreshold = 80;
            }
            if (!exportOptions.nearDuplicatesMinTermCount) {
                exportOptions.nearDuplicatesMinTermCount = 25;
            }
            this.onChange.includeSeperateEmailAttachments(exportOptions.includeSeperateEmailAttachments, true);
            this.onChange.includeContainerReferences(exportOptions.includeContainerReferences, true);
            this.extraOptions.maxRecordsPerFile = exportOptions.maxManifestRecords > 0;
            if (!this.disabled.includeFullText()) {
                this.exportOptions.includeFullText = this.extraOptions.includeFullText = this.exportOptions.maximumEmbeddedTextSize === exportOptions.maximumEmbeddedTextSize && this.exportOptions.maximumEmbeddedTextSize !== 0;
                this.exportOptions.excludeEmailHeadersInLoadFile = exportOptions.excludeEmailHeadersInLoadFile;
            }
            this.validation.directory.nativeSubdirectoryInput.name = isExportSettingsPage ? exportOptions.nativeSubdirectoryName : this.exportOptions.nativeSubdirectoryName;
            this.defaultNativeSubdirectoryName = this.validation.directory.nativeSubdirectoryInput.name;
            this.defaultEmailOutputFormat = this.exportOptions.emailOutputFormat;
            this.validation.directory.textSubdirectoryInput.name = isExportSettingsPage ? exportOptions.textSubdirectoryName : this.exportOptions.textSubdirectoryName;
            this.defaultExtractedTextName = this.validation.directory.textSubdirectoryInput.name;           
            this.defaultExcludeEmailHeaders = this.exportOptions.excludeEmailHeaders;
            this.defaultHighlightSearchTermsSelection = this.exportOptions.highlightTerms;
            this.defaultGenerateRemainingImagesSelection = this.exportOptions.convertImagesToPdf;
            this.onChange.productionSettingType('Extracted Text', true);
            this.validation.directory.pdfSubdirectoryInput.name = isExportSettingsPage ? exportOptions.pdfSubdirectoryName : this.exportOptions.pdfSubdirectoryName;
            this.onChange.productionSettingType('PDF', true);
        }
    }

    loadData(): void {
        if (!this.optionsDisabled && !this.isExportToRelativity && !this.isExportSettingsPage) {
            this.loadExportTemplates('fields');
            this.loadExportTemplates('settings');
            if (this.isReefReviewProject) {
                this.restService.post(Endpoint.connectorManager_getReviewConnectors, { systemScope: true }).then(response => {
                    if (response?.reviewConnectors?.length > 0 && response.reviewConnectors.find(connector => connector.reviewSystem === ReviewSystem.REEF_REVIEW)){
                        this.isReefReviewWithConnector = true;
                        // a reef review connector is set so load the reef review data areas
                        this.loadExportDataAreas(false);    
                    } else {
                        this.isReefReviewWithConnector = false;
                        this.loadExportDataAreas();
                    }
                });
            } else {
                this.loadExportDataAreas();
            }
        }
        if (!this.isExportSettingsPage) {
            // initialize exportStreamName and tableName related validation objects
            this.initializeExportStreamNameDescriptionComponent();
            this.initializeTableNameDescriptionComponent();
            this.loadExportStreams();
            if (!this.selectedExportStream) {
                this.defaultExportOptions();
            }
        }
        this.loadMetadataProperties();
        this.isNewExport = true;
        if (this.selectedExportStream) {
            this.isNewExport = false;
            if (this.selectedExportVolume) {
                this.setExportOptions(this.selectedExportVolume.options);
            } else {
                this.loadExportStreamOptions();
            }
        }
    }

    loadExportStreams(): void {
        this.isBusy = true;
        this.isBusyMessage = 'Loading...';
        this.extraOptions.isBusy.push(Endpoint.workingSetManager_listExportStreams);
        this.restService.post(Endpoint.workingSetManager_listExportStreams, {
            filters: [
                { attribute: 'reviewProductions', value: 'false', operator: 'EQUALS' },
                { attribute: 'reviewStream', value: 'false', operator: 'EQUALS' }
            ],
            handle: this.commonService.projectData?.handle
        }).then(response => {
            this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.workingSetManager_listExportStreams), 1);
            this.isBusy = this.extraOptions.isBusy.length > 0;
            if (response && response.exportStreams) {
                if (this.selectedExportStream) {
                    response.exportStreams = response.exportStreams.filter(expStream => expStream.handle === this.selectedExportStream.handle);
                }
                (response.exportStreams as Array<any>).map(responseItem => new ExportStream(responseItem)).forEach((item) => {
                    this.extraOptions.exportStreams.push(item);
                });
                this.extraOptions.exportStreamNames = this.extraOptions.exportStreams.map(es => es.name);
                if (this.isNewExport) {
                    this.commonService.sendMessage(MessageType.isNewExport, true);
                }
            }
        }, error => {
            this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.workingSetManager_listExportStreams), 1);
            this.isBusy = this.extraOptions.isBusy.length > 0;
        });
    }

    defaultExportOptions(): void {
        if (this.extraOptions.exportSettingsTemplates?.project.length > 0) {
            this.exportOptions.metadataSettingsTemplateHandle = this.extraOptions.exportSettingsTemplates.project[0].handle;
            this.handleSettingsTemplateSelectionChange(this.exportOptions.metadataSettingsTemplateHandle);
            return;
        }
        if (this.defaultExport || this.exportStreamNameDescriptionComponent.name === '') {
            this.restService.post(Endpoint.workingSetManager_getDefaultExportStreamOptions, {
                handle: this.commonService.currentProject?.handle,
                entityType: 'PROJECT'
            }).then(response => {
                this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.workingSetManager_getDefaultExportStreamOptions), 1);
                this.isBusy = this.extraOptions.isBusy.length > 0;
                if (response && response.options) {
                    this.defaultExport = false;
                    this.exportOptions.documentIdPrefix = response.options.documentIdPrefix;
                    this.extraOptions.documentPrefixes = [this.exportOptions.documentIdPrefix];
                    this.exportOptions.volumeLabel = response.options.volumeLabel;
                    this.validation.volumeLabel.check();
                    this.extraOptions.includeMetadata = true;
                }
            }, error => {
                this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.exportStreamManager_getExportStream), 1);
                this.isBusy = this.extraOptions.isBusy.length > 0;
                this.defaultExport = false;
            });
        }
    }

    handleSettingsTemplateSelectionChange(handle: string): void {

        let group = '';
        if (this.extraOptions.exportSettingsTemplates.project.some(t => t.handle === handle)) {
            group = 'Project';
        } else if (this.extraOptions.exportSettingsTemplates.organization.some(t => t.handle === handle)) {
            group = 'Organization';
        } else if (this.extraOptions.exportSettingsTemplates.system.some(t => t.handle === handle)) {
            group = 'System';
        }

        const isSystemUser = group === 'System' ? true : false;
        this.restService.post(Endpoint.projectManager_getExportOptions, { projectHandle: handle, systemScope: isSystemUser }).then(response => {
            this.setExportOptions(response.exportSettings, true);
        });
    }

    loadExportTemplates(type: string, handle?: string): void {
        this.isBusy = true;
        this.isBusyMessage = 'Loading...';

        // Clear existing templates to prevent duplicates when reloading export settings page or navigating within settings
        if (type === 'fields') {
            this.extraOptions.exportFieldTemplates.project = [];
            this.extraOptions.exportFieldTemplates.organization = [];
            this.extraOptions.exportFieldTemplates.system = [];
        }

        if (type === 'fields') {
            this.extraOptions.isBusy.push(Endpoint.projectManager_listExportMetadataProfile);
            this.restService.post(Endpoint.projectManager_listExportMetadataProfile, { handle: handle ? handle : this.commonService.currentProject?.handle }).then(response => {
                
                this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.projectManager_listExportMetadataProfile), 1);
                this.isBusy = this.extraOptions.isBusy.length > 0;

                let overlayProfileName = '',
                    overlayProfileHandle = '',
                    defaultProfileName = '',
                    defaultProfileHandle = '';

                if (response && response.profiles) {
                    (response.profiles as Array<any>).map(responseItem => new ExportMetadataProfile(responseItem)).forEach((item) => {
                        this.extraOptions.exportFieldTemplates.project.push(item);
                        if (!this.exportOptions.metadataTemplateHandle && item.defaultProfile) {
                            this.exportOptions.metadataTemplateHandle = item.handle;
                        }

                        if (item.name === REEF_REVIEW_OVERLAY_FIELD_SETTINGS) {
                            overlayProfileName = item.name;
                            overlayProfileHandle = item.handle;
                        } else if (item.defaultProfile) {
                            defaultProfileName = item.name;
                            defaultProfileHandle = item.handle;
                        }
                    });

                    if (!this.exportOptions.overlayMetadataTemplateHandle && this.exportOptions.overlayManifest) {
                            if (overlayProfileHandle) {
                                this.exportOptions.overlayMetadataTemplateHandle = overlayProfileHandle;
                                this.exportOptions.overlayMetadataTemplateName = overlayProfileName;
                            } else if (defaultProfileHandle) {
                                this.exportOptions.overlayMetadataTemplateHandle = defaultProfileHandle;
                                this.exportOptions.overlayMetadataTemplateName = defaultProfileName;
                            }
                        }
                }
            }, () => {
                this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.projectManager_listExportMetadataProfile), 1);
                this.isBusy = this.extraOptions.isBusy.length > 0;
            });
        } else {
            const template = new Template({
                name: 'Default Export Settings',
                handle: this.commonService.currentProject?.handle
            });
            this.extraOptions.exportSettingsTemplates.project.push(template);
            if (!this.exportOptions.metadataSettingsTemplateHandle) {
                this.exportOptions.metadataSettingsTemplateHandle = template.handle;
            }
        }

        // ORG fields or settings templates
        const tempType = type === 'fields' ? TemplateType.EXPORT_FIELDS : TemplateType.EXPORT_SETTINGS;
        this.extraOptions.isBusy.push(Endpoint.orgManager_listTemplates);
        this.restService.post(Endpoint.orgManager_listTemplates, { scope: 'ORG_LEVEL', tempType: tempType }).then(response => {
            this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.orgManager_listTemplates), 1);
            this.isBusy = this.extraOptions.isBusy.length > 0;
            if (response && response.templates) {
                (response.templates as Array<any>).map(responseItem => new Template(responseItem)).forEach((template) => {
                    if (type === 'fields') {
                        this.extraOptions.exportFieldTemplates.organization.push(template);
                    } else {
                        this.extraOptions.exportSettingsTemplates.organization.push(template);
                    }
                });
            }
        }, error => {
            this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.orgManager_listTemplates), 1);
            this.isBusy = this.extraOptions.isBusy.length > 0;
        });

        if (this.isSystemUserWithPermissions) {
            const tempType = type === 'fields' ? TemplateType.EXPORT_FIELDS : TemplateType.EXPORT_SETTINGS;
            this.extraOptions.isBusy.push(Endpoint.orgManager_listTemplates);
            this.restService.post(Endpoint.orgManager_listTemplates, { scope: 'SYSTEM_LEVEL', tempType: tempType, systemScope: true }).then(response => {
                this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.orgManager_listTemplates), 1);
                this.isBusy = this.extraOptions.isBusy.length > 0;
                if (response && response.templates) {
                    (response.templates as Array<any>).map(responseItem => new Template(responseItem)).forEach((item) => {
                        if (this.isReefReviewProject) {
                            if (item.name === 'Reef Review Export Field Settings') {
                                this.exportOptions.metadataTemplateHandle = item.handle;
                                this.exportOptions.metadataTemplateName = item.name;
                            } else if (item.name === 'Reef Review Overlay Field Settings') {
                                this.exportOptions.overlayManifest = true;
                                this.exportOptions.overlayMetadataTemplateHandle = item.handle;
                                this.exportOptions.overlayMetadataTemplateName = item.name;
                            }
                        }
                        if (type === 'fields') {
                            this.extraOptions.exportFieldTemplates.system.push(item);
                        } else {
                            this.extraOptions.exportSettingsTemplates.system.push(item);
                        }
                    });
                }
            }, error => {
                this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.orgManager_listTemplates), 1);
                this.isBusy = this.extraOptions.isBusy.length > 0;
            });
        }
    }

    loadExportDataAreas(loadDrDataAreas = true): void {
        if (!loadDrDataAreas && !this.exportOptions.reviewProjectId) {
            return;
        }
        const endpoint = this.isReefReviewProject && !loadDrDataAreas ? Endpoint.dataAreaManager_getDataAreaByReviewProject : Endpoint.orgManager_listExportDataAreas;
        const payload = this.isReefReviewProject && !loadDrDataAreas ? { reviewProjectId: this.exportOptions.reviewProjectId } : {};
        this.isBusy = true;
        this.isBusyMessage = 'Loading...';
        this.extraOptions.isBusy.push(endpoint);
        this.restService.post(endpoint, payload).then(response => {
            this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(endpoint), 1);
            this.isBusy = this.extraOptions.isBusy.length > 0;
            if (response && response.dataArea) {
                this.extraOptions.exportDataAreas.push(response.dataArea);
                this.selectedDataAreaName = response.dataArea.name;
                this.exportOptions.dataAreaHandle = response.dataArea.handle;
                this.validation.dataAreaHandle.hasError = false;
            }
            if (response && response.exportDataAreas) {
                const existingDataArea = response?.exportDataAreas?.find(eda => eda?.handle === this.exportOptions?.dataAreaHandle);
                this.exportOptions.dataAreaHandle = existingDataArea ? this.exportOptions?.dataAreaHandle : null;
                (response.exportDataAreas as Array<any>).map(responseItem => new DataArea(responseItem)).forEach((item) => {
                    this.extraOptions.exportDataAreas.push(item);
                });
            }
        }, error => {
            this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(endpoint), 1);
            this.isBusy = this.extraOptions.isBusy.length > 0;
            if (!loadDrDataAreas) {
                this.selectedDataAreaName = null;
                this.exportOptions.dataAreaHandle = null;
            }
        });
    }

    loadMetadataProperties = () => {
        this.isBusy = true;
        this.isBusyMessage = 'Loading...';
        this.extraOptions.isBusy.push(Endpoint.viewManager_getMetadataProperties);
        this.restService.post(Endpoint.viewManager_getMetadataProperties, { applyMetadataTemplate: true, stampingFieldsOnly: true }).then(response => {
            this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.viewManager_getMetadataProperties), 1);
            this.isBusy = this.extraOptions.isBusy.length > 0;
            if (response && response.propertiesAsXML) {
                const propertiesAsXML = jquery.parseXML(response.propertiesAsXML);
                if (propertiesAsXML && propertiesAsXML.children && propertiesAsXML.children[0] &&
                    propertiesAsXML.children[0].children && propertiesAsXML.children[0].children[0] && propertiesAsXML.children[0].children[0].children) {
                    Array.from(propertiesAsXML.children[0].children[0].children as HTMLCollection).forEach(element => {
                        if (!element.attributes || !element.attributes['tokenizationtype'] || element.attributes['tokenizationtype'].value !== 'stored_only') {
                            this.extraOptions.metadataProperties.push(element.nodeName);
                        }
                    });
                    this.extraOptions.metadataProperties.sort();
                }
            }
        }, error => {
            this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.viewManager_getMetadataProperties), 1);
            this.isBusy = this.extraOptions.isBusy.length > 0;
        });
    }

    loadExportStreamOptions = () => {
        this.isBusy = true;
        this.isBusyMessage = 'Loading...';
        this.extraOptions.isBusy.push(Endpoint.exportStreamManager_getExportStream);
        if (this.selectedExportStream) {
            this.restService.post(Endpoint.exportStreamManager_getExportStream, { handle: this.selectedExportStream.handle }).then(response => {
                this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.exportStreamManager_getExportStream), 1);
                this.isBusy = this.extraOptions.isBusy.length > 0;
                if (response && response.exportStream) {
                    this.selectedExportStream = new ExportStream(response.exportStream);
                    this.setExportOptions(this.selectedExportStream.options);
                    if (this.isReefReviewWithConnector && this.exportOptions.reviewProjectId) {
                        this.loadExportDataAreas(false);
                    }
                    this.validation.valid();
                }
            }, error => {
                this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.exportStreamManager_getExportStream), 1);
                this.isBusy = this.extraOptions.isBusy.length > 0;
            });
        }
    }

    loadFolderByOptions() {
        this.restService.post(Endpoint.realmManager_getDREnumNames, {
            enumType: DREnumType.FOLDER_BY_FIELD
        }).then(response => {
            if (response?.names?.length > 0) {
                response?.names?.unshift('');
                this.folderByOptions = response.names;
            }
        });
    }

    // where stream could be an ExportStream object or an ExportVolume object
    setOptionNames = (opts: ExportStreamOptions) => {
        if (this.optionsDisabled && opts) {
            this.extraOptions.exportFieldTemplates.organization.push(new Template({ name: opts.metadataTemplateName, handle: opts.metadataTemplateHandle }));
            this.extraOptions.exportFieldTemplates.organization.push(new Template({ name: opts.overlayMetadataTemplateName, handle: opts.overlayMetadataTemplateHandle }));
            this.extraOptions.exportDataAreas.push(new DataArea({ name: opts.dataAreaName, handle: opts.dataAreaHandle }));
        }
    }

    setExportOptions = (options: ExportStreamOptions, retainFields?: boolean) => {
        this.extraOptions.exportStreamName = retainFields ? this.extraOptions.exportStreamName : this.selectedExportStream?.name;

        if (retainFields) {
            options.dataAreaHandle = this.exportOptions.dataAreaHandle;
            options.metadataTemplateHandle = this.exportOptions.metadataTemplateHandle;
            options.metadataSettingsTemplateHandle = this.exportOptions.metadataSettingsTemplateHandle;
            options.overlayMetadataTemplateHandle = this.exportOptions.overlayMetadataTemplateHandle;
            options.postProcessDataAreaHandle = this.exportOptions.postProcessDataAreaHandle;
            options.documentsToExport = this.exportOptions.documentsToExport;
            options.dataAreaName = this.exportOptions.dataAreaName;

            if (this.currentReviewSystem !== ReviewSystem.NONE && this.exportOptions.reviewProjectId) {
                options.reviewProjectId = this.exportOptions.reviewProjectId;
                options.folderByMetadataField = this.exportOptions.folderByMetadataField;
            }

            if (this.currentReviewSystem === ReviewSystem.RELATIVITY) {
                options.generateCsv = this.exportOptions.generateCsv;
            }
        }

        if (options) {
            this.exportOptions = options;

            this.setOptionNames(options);
            this.documentsToExport.query = this.xmlService.xmlToQueryConverter(this.exportOptions.documentsToExport) as string;
            if (this.documentsToExport.query?.startsWith('(') && this.documentsToExport.query?.endsWith(')')) {
                this.documentsToExport.query = this.documentsToExport.query.slice(1, -1);
            }
            this.documentsToExport.allDocs = this.documentsToExport.selectTagsDisabled = this.documentsToExport.query === 'ALLDOCS';
            if (this.exportOptions.includeNearDuplicates) {
                this.exportOptions.nearDuplicatesThreshold = this.exportOptions.nearDuplicatesThreshold;
            } else {
                this.exportOptions.nearDuplicatesThreshold = 80;
                this.exportOptions.nearDuplicatesMinTermCount = 25;
            }
            this.extraOptions.maxRecordsPerFile = false;
            if (!this.exportOptions.maxManifestRecords) {
                this.exportOptions.maxManifestRecords = 0;
            } else if (!this.disabled.maxRecordsPerFile()) {
                this.extraOptions.maxRecordsPerFile = true;
            }
            if (!this.disabled.includeFullText()) {
                this.extraOptions.includeFullText = this.exportOptions.maximumEmbeddedTextSize === MAXIMUM_EMBEDDED_TEXT_SIZE;
            }
            if (this.exportOptions.dateTimeDelimiter === ' ') {
                this.exportOptions.dateTimeDelimiter = 'Space';
            }
            if (this.exportOptions.docIdsByPrefix && Object.keys(this.exportOptions.docIdsByPrefix).length > 0) {
                this.extraOptions.documentPrefixes = [];
                for (const key in this.exportOptions.docIdsByPrefix) {
                    if (Object.prototype.hasOwnProperty.call(this.exportOptions.docIdsByPrefix, key)) {
                        this.extraOptions.documentPrefixes.push(key);
                    }
                }
                this.extraOptions.documentPrefixes = this.extraOptions.documentPrefixes.sort((a, b) => a.localeCompare(b, 'en-US', { caseFirst: 'upper' }));
            } else {
                this.extraOptions.documentPrefixes = [this.exportOptions.documentIdPrefix];
            }
            if (!this.exportOptions.includeNativeFiles) {
                this.exportOptions.emailOutputFormat = null;
            }
            if (this.exportOptions.emailOutputFormat) {
                this.defaultEmailOutputFormat = this.exportOptions.emailOutputFormat;
            }
            if (this.exportOptions.excludeEmailHeaders) {
                this.defaultExcludeEmailHeaders = this.exportOptions.excludeEmailHeaders;
            }
            if(this.exportOptions.highlightTerms) {
                this.defaultHighlightSearchTermsSelection = this.exportOptions.highlightTerms;
            }
            if(this.exportOptions.convertImagesToPdf) {
                this.defaultGenerateRemainingImagesSelection = this.exportOptions.convertImagesToPdf;
            }
            if (!this.exportOptions.includeTiffConversion) {
                this.exportOptions.tiffMode = null;
                if (!this.exportOptions.includePdfConversion) {
                    this.exportOptions.tiffBW = null;
                }
            }
            if (this.exportOptions.nativeSubdirectoryName && this.exportOptions.includeNativeFiles) {
                this.validation.directory.nativeSubdirectoryInput.name = this.exportOptions.nativeSubdirectoryName;
                this.defaultNativeSubdirectoryName = this.exportOptions.nativeSubdirectoryName;
            } else {
                this.validation.directory.nativeSubdirectoryInput.name = '';
                this.defaultNativeSubdirectoryName = ''
            }
            if (this.exportOptions.textSubdirectoryName && this.exportOptions.includeTextConversion) {
                this.validation.directory.textSubdirectoryInput.name = this.exportOptions.textSubdirectoryName;
                this.defaultExtractedTextName = this.exportOptions.textSubdirectoryName;
            } else {
                this.validation.directory.textSubdirectoryInput.name = '';
                this.defaultExtractedTextName = '';
            }
            if (this.exportOptions.pdfSubdirectoryName && this.exportOptions.includePdfConversion) {
                this.validation.directory.pdfSubdirectoryInput.name = this.exportOptions.pdfSubdirectoryName;
            } else {
                this.validation.directory.pdfSubdirectoryInput.name = '';
            }
            if (this.exportOptions.tiffSubdirectoryName) {
                this.validation.directory.tiffSubdirectoryInput.name = this.exportOptions.tiffSubdirectoryName;
            }
            if (this.exportOptions.reviewFolderPath) {
                this.documentFolderPath = this.exportOptions.reviewFolderPath.replace(/\//g, ' \\ ');
                this.selectedFolderPath = this.documentFolderPath;
                this.isFolderPathSelected = !this.exportOptions.createReviewFolder;
            }
            if (this.exportOptions.createReviewFolder && !this.optionsDisabled) {
                this.onChange.createReviewSystemFolder();
            }
            if (this.exportOptions.dataAreaName && this.isReefReviewProject) {
                this.selectedDataAreaName = this.exportOptions.dataAreaName;
            }
            if (this.optionsDisabled && this.exportOptions.reviewSystem && this.exportOptions.reviewProjectId) {
                this.setReviewSystemFromOptions(this.exportOptions.reviewSystem);
            }
            // Clear all startingDocumentId validation states
            this.validation.startingDocumentId.invalid = false;
            this.validation.startingDocumentId.hasError = false;
            this.validation.startingDocumentId.isFieldEmptyOnBlur = false;
            this.validation.startingDocumentId.defaultStartingDocumentId = this.exportOptions.startingDocumentId;
            this.extraOptions.startingDocumentIdDisplay = this.validation.startingDocumentId.defaultStartingDocumentId.toString();
            this.selectedId = this.extraOptions.startingDocumentIdDisplay;
            this.validation.startingDocumentId.parse();

            if (!this.exportOptions.includeStamp) {
                this.exportOptions.stampFontName = 'Unifont';
                this.exportOptions.stampFontSize = 10;
                this.exportOptions.stampBottomRightLine = 1;
                this.exportOptions.stampBottomRightType = StampType.BATES;
            }
            this.stamping.init();

            if (this.optionsDisabled) {
                this.extraOptions.generateSearchReports = this.exportOptions.generateSearchReports;
                this.extraOptions.includeMetadata = this.exportOptions.expandFields;
            } else {
                this.extraOptions.generateSearchReports = false;
            }

            if (this.exportOptions.custodianReportQueries && this.exportOptions.custodianReportQueries.length > 0) {
                this.bulkSearchComponent.init(this.exportOptions.custodianReportQueries);
                this.bulkSearchComponent.searchOptions[1].isChecked = this.exportOptions.expandFields;
            }

            // TODO-AFTER-BACKEND-FIX: remove this if-block after ST work is complete on ECASL-36124
            // currently backend is wrongly sending a default handle for overlayMetadataTemplateHandle when from UI a null value was sent
            if (!this.exportOptions.overlayManifest && this.exportOptions.overlayMetadataTemplateHandle) {
                this.exportOptions.overlayMetadataTemplateHandle = null;
            }
        } 
        if (this.disabled.exportToDb() && this.tableNameDescriptionComponent) {
            this.tableNameDescriptionComponent.formValid = true;
            this.validation.tableName.hasError = false;
            this.validation.tableName.invalid = false;
        }
        this.isExportVolume = retainFields ? false : true;
        this.isNewExport = retainFields ? true : false;
    }

    restrictNumeric = (event): boolean => {
        if (event) {
            return (event.charCode === 8 || event.charCode === 0) ? false : event.charCode >= 48 && event.charCode <= 57;
        }
        return false;
    }

    parseNumeric = (modelName: string, min?: number, max?: number): void => {
        if (modelName) {
            const field = _.get(this, modelName);
            if (field) {
                let val = parseInt(field, 10);
                if (isNaN(val)) {
                    return;
                }
                if (isNumber(min) && min > val) {
                    val = min;
                }
                if (isNumber(max) && val > max) {
                    val = max;
                }
                _.set(this, modelName, val);
            }
        }
    }

    getExportStreamOptions = (): ExportStreamOptions => {
        const exportStreamOptions: ExportStreamOptions = _.cloneDeep(this.exportOptions);
        if (exportStreamOptions.nearDuplicatesThreshold) {
            exportStreamOptions.nearDuplicatesThreshold = this.exportOptions.nearDuplicatesThreshold / 100;
        }
        if (exportStreamOptions.includeNearDuplicates) {
            exportStreamOptions.nearDuplicatesThreshold = exportStreamOptions.nearDuplicatesThreshold ?? 0;
            exportStreamOptions.nearDuplicatesMinTermCount = exportStreamOptions.nearDuplicatesMinTermCount ?? 0;
        }
        if (!exportStreamOptions.maxManifestRecords) {
            exportStreamOptions.maxManifestRecords = 0;
        }
        if (!exportStreamOptions.maximumEmbeddedTextSize) {
            exportStreamOptions.maximumEmbeddedTextSize = 0;
        }
        if (!exportStreamOptions.tableName) {
            exportStreamOptions.tableName = null;
        }
        if (exportStreamOptions.dateTimeDelimiter === 'Space') {
            exportStreamOptions.dateTimeDelimiter = ' ';
        }
        if (this.validation.directory.nativeSubdirectoryInput.name) {
            exportStreamOptions.nativeSubdirectoryName = this.validation.directory.nativeSubdirectoryInput.name;
        }
        if (!exportStreamOptions.nativeSubdirectoryName) {
            exportStreamOptions.nativeSubdirectoryName = null;
        }
        if (this.validation.directory.textSubdirectoryInput.name) {
            exportStreamOptions.textSubdirectoryName = this.validation.directory.textSubdirectoryInput.name;
        }
        if (!exportStreamOptions.textSubdirectoryName) {
            exportStreamOptions.textSubdirectoryName = null;
        }
        if (this.validation.directory.pdfSubdirectoryInput.name) {
            exportStreamOptions.pdfSubdirectoryName = this.validation.directory.pdfSubdirectoryInput.name;
        }
        if (!exportStreamOptions.pdfSubdirectoryName) {
            exportStreamOptions.pdfSubdirectoryName = null;
        }
        if (this.validation.directory.tiffSubdirectoryInput.name) {
            exportStreamOptions.tiffSubdirectoryName = this.validation.directory.tiffSubdirectoryInput.name;
        }
        if (!exportStreamOptions.tiffSubdirectoryName) {
            exportStreamOptions.tiffSubdirectoryName = null;
        }
        if (!isBoolean(exportStreamOptions.tiffBW)) {
            exportStreamOptions.tiffBW = true;
        }
        if (!this.extraOptions.maxRecordsPerFile) {
            exportStreamOptions.maxManifestRecords = 0;
        }
        if (!this.extraOptions.includeFullText) {
            exportStreamOptions.excludeEmailHeadersInLoadFile = false;
        }
        if (!exportStreamOptions.emailOutputFormat) {
            exportStreamOptions.emailOutputFormat = EmailOutputFormat.HTML_MHTML_FORMAT;
        }
        if (!exportStreamOptions.includeStamp) {
            delete exportStreamOptions.stampFontName;
            delete exportStreamOptions.stampFontSize;
            delete exportStreamOptions.stampTopLeftType;
            delete exportStreamOptions.stampTopLeftLine;
            delete exportStreamOptions.stampTopLeftValue;
            delete exportStreamOptions.stampTopCenterType;
            delete exportStreamOptions.stampTopCenterLine;
            delete exportStreamOptions.stampTopCenterValue;
            delete exportStreamOptions.stampTopRightType;
            delete exportStreamOptions.stampTopRightLine;
            delete exportStreamOptions.stampTopRightValue;
            delete exportStreamOptions.stampBottomLeftType;
            delete exportStreamOptions.stampBottomLeftLine;
            delete exportStreamOptions.stampBottomLeftValue;
            delete exportStreamOptions.stampBottomCenterType;
            delete exportStreamOptions.stampBottomCenterLine;
            delete exportStreamOptions.stampBottomCenterValue;
            delete exportStreamOptions.stampBottomRightType;
            delete exportStreamOptions.stampBottomRightLine;
            delete exportStreamOptions.stampBottomRightValue;
        }
        exportStreamOptions.custodianReportQueries = [];
        if (this.extraOptions.generateSearchReports || this.exportOptions.highlightTerms) {
            const searchRequest = this.bulkSearchComponent?.getBulkSearchRequestData();
            exportStreamOptions.generateSearchReports = this.extraOptions.generateSearchReports;
            if (searchRequest) {
                if (searchRequest.queries) {
                    exportStreamOptions.custodianReportQueries = searchRequest.queries;
                    exportStreamOptions.expandFields = this.bulkSearchComponent?.searchOptions[1].isChecked;
                } else if (searchRequest.custodianQueriesFileName) {
                    exportStreamOptions.custodianQueriesFileName = searchRequest.custodianQueriesFileName;
                } else if (searchRequest.custodianQueriesFileData) {
                    exportStreamOptions.custodianQueriesFileData = searchRequest.custodianQueriesFileData;
                    exportStreamOptions.fileName = searchRequest.fileName;
                }
            }
        }
        if (this.currentReviewSystem === ReviewSystem.NONE) {
            delete exportStreamOptions.reviewProjectId;
            delete exportStreamOptions.reviewFolderId;
            delete exportStreamOptions.reviewSystem;
            delete exportStreamOptions.reviewFolderName;
            delete exportStreamOptions.reviewFolderPath;
        } else {
            exportStreamOptions.reviewSystem = this.currentReviewSystem;
            if (this.currentReviewSystem === ReviewSystem.REEF_REVIEW) {
                if (this.exportOptions.createReviewFolder) {
                   exportStreamOptions.reviewFolderName = null;
                   exportStreamOptions.reviewFolderPath = null;
                }
                exportStreamOptions.textSubdirectoryName = null;
                exportStreamOptions.nativeSubdirectoryName = null;
                exportStreamOptions.pdfSubdirectoryName = null;
            }
        }

        exportStreamOptions.oleSubdirectoryName = null;
        exportStreamOptions.exportTarget = ExportTarget.FILE;
        return exportStreamOptions;
    }

    validateBulkQueries = (): void => {
        this.bulkSearchComponent.closePopovers();
        const getBulkSearchRequestData = this.bulkSearchComponent?.getBulkSearchRequestData(true);
        this.bulkSearchComponent?.hasConnectorPath ? getBulkSearchRequestData?.then(response => {
            this.validateBulkSearch(response);
        }) : this.validateBulkSearch(getBulkSearchRequestData);
    }

    validateBulkSearch = (requestData): void => {
        if (requestData) {
            this.bulkSearchComponent.isBulkQueryValid = false;
            requestData.includeFamilyMembers = false;
            requestData.includeSynonyms = false;
            requestData.produceSummaryReport = false;
            requestData.attributes[0].value = this.commonService.projectData.handle;
            requestData.attributes[1].value = this.commonService.projectData.name;
            requestData.viewHandleList.push(this.commonService.projectData.handle);
            this.isBusy = true;
            this.isBusyMessage = 'Validating Queries...';
            this.extraOptions.isBusy.push(Endpoint.viewManager_validateBulkSearch);
            this.restService.post(Endpoint.viewManager_validateBulkSearch, requestData).then(response => {
                if (response && response.handle) {
                    this.restService.post(Endpoint.viewManager_getValidateBulkSearchResult, { taskHandle: response.handle }).then(validateResult => {
                        this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.viewManager_validateBulkSearch), 1);
                        this.isBusy = this.extraOptions.isBusy.length > 0;
                        if (validateResult) {
                            this.bulkSearchComponent.isBulkQueryValid = validateResult.numberOfErrors === 0 && validateResult.numberOfWarnings === 0;
                            this.bulkSearchComponent.showValidationResult(validateResult);
                            this.bulkSearchComponent.bulkSearchFilePath = validateResult.bulkSearchFilePath;
                        }
                    }, error => {
                        this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.viewManager_validateBulkSearch), 1);
                        this.isBusy = this.extraOptions.isBusy.length > 0;
                    });
                }
            }, error => {
                this.extraOptions.isBusy.splice(this.extraOptions.isBusy.indexOf(Endpoint.viewManager_validateBulkSearch), 1);
                this.isBusy = this.extraOptions.isBusy.length > 0;
            });
        }
    }

    valid = (shouldFocusOnError: boolean = false): boolean => {
        // Reset child component popover states before validation so Angular detects
        // the false→true transition. Only on explicit validation (Run Export),
        // not on continuous isSaveDisabled() calls which would break X dismiss.
        if (shouldFocusOnError) {
            this.validation.maxManifestRecords.invalid = false;
            this.validation.maxManifestRecords.hasError = false;
            this.validation.postProcessDataAreaHandle.invalid = false;
            this.validation.postProcessDataAreaHandle.hasError = false;
            this.validation.dateFormat.hasError = false;
            this.validation.dateTimeDelimiter.hasError = false;
            this.validation.timeFormat.hasError = false;
            this.validation.tableName.invalid = false;
            this.validation.directory.nativeSubdirectoryInput.invalid = false;
            this.validation.directory.nativeSubdirectoryInput.hasError = false;
            this.validation.directory.textSubdirectoryInput.invalid = false;
            this.validation.directory.textSubdirectoryInput.hasError = false;
            this.validation.directory.pdfSubdirectoryInput.invalid = false;
            this.validation.directory.pdfSubdirectoryInput.hasError = false;
            this.validation.directory.tiffSubdirectoryInput.invalid = false;
            this.validation.directory.tiffSubdirectoryInput.hasError = false;
            this.changeDetector.detectChanges();
        }
        const valid = this.validation.valid();
        if (!valid && shouldFocusOnError && this.errorPopovers) {
            const mainPopovers = this.errorPopovers?.toArray() || [];
            const outputPopovers = this.exportOutputFormattingOptionsComponent?.errorPopovers?.toArray() || [];
            const productionPopovers = this.exportProductionImagingOptionsComponent?.errorPopovers?.toArray() || [];
            const allPopovers = [...mainPopovers, ...outputPopovers, ...productionPopovers];

            // Force all error popovers to show — directly resets closingByClick
            // and calls setPopover() which sets display:block on the DOM element,
            // bypassing Angular's change detection which may not fire the setter
            // when invalid stays true→true across check() calls.
            allPopovers.forEach(popover => {
                if (popover && popover.resScrollablePopover && popover.popoverType !== 'info') {
                    popover.closingByClick = false;
                    popover.setPopover();
                }
            });

            let visiblePopovers = allPopovers
                .filter(popover => popover?.resScrollablePopover);
            if (visiblePopovers && visiblePopovers.length > 0) {
                this.commonService.comboboxDropdownHidden = true;

                    // Sort by position (top to bottom, left to right)
                    visiblePopovers = visiblePopovers.sort((a, b) => {
                        const rectA = a.inputElement.getBoundingClientRect();
                        const rectB = b.inputElement.getBoundingClientRect();
                        // Primary sort by vertical position (top)
                        if (rectA.top > rectB.top) { return 1; }
                        if (rectA.top < rectB.top) { return -1; }
                        // Secondary sort by horizontal position (left) when tops are equal
                        if (rectA.left > rectB.left) { return 1; }
                        if (rectA.left < rectB.left) { return -1; }
                        return 0;
                    });

                    // Find the first popover that is not currently focused
                    // This prevents focusing on a field that already has focus (and likely already shows its error)
                    const currentlyFocusedElement = document.activeElement;
                    let popoverToFocus = visiblePopovers.find(popover => {
                        const popoverInput = popover.inputElement.tagName === 'INPUT'
                            ? popover.inputElement
                            : popover.inputElement.querySelector('input');
                        return popoverInput !== currentlyFocusedElement;
                    });

                    // If all error fields are focused (edge case), fall back to the first one
                    if (!popoverToFocus) {
                        popoverToFocus = visiblePopovers[0];
                    }

                    popoverToFocus.focusOnInput();
                    this.commonService.comboboxDropdownHidden = false;
                }
            }
        return valid;
    }

    nameExists(name: string): boolean {
        let exists = false;
        const empty = DrObject.isEmpty(name);
        if (!empty && this.extraOptions.exportStreamNames && (_.includes(this.extraOptions.exportStreamNames, name) || _.includes(this.nameAlreadyExists, name))) {
            exists = true;
            this.setExportNameState(true);
        }
        return exists;
    }

    validateTableName(): void {
        this.tableNameDescriptionComponent.name = this.exportOptions.tableName.replace(/^\s+/, '');  // remove leading whitespaces;
        const empty = DrObject.isEmpty(this.tableNameDescriptionComponent.name);
        if (!empty && !this.validation.tableName.invalid && this.validation.tableName.hasValidCharacters) {
            this.isBusyMessage = `Validating DB Table Name ...`;
            this.tableNameDescriptionComponent.name = this.exportOptions.tableName;
            this.validateName(this.tableNameDescriptionComponent);
        }
    }

    validateExportStreamName(name: string): void {
        this.exportStreamNameDescriptionComponent.name = name.replace(/^\s+/, '');  // remove leading whitespaces;
        const exists = this.nameExists(this.exportStreamNameDescriptionComponent.name);
        const empty = DrObject.isEmpty(this.exportStreamNameDescriptionComponent.name);
        if (exists && !this.exportNameNeedsValidation) {
            this.exportStreamNameDescriptionComponent.formValid = true;
            this.validation.exportStreamName.invalid = false;
            this.exportStreamNameDescriptionComponent.validateNameError = null;
            this.validateName(this.exportStreamNameDescriptionComponent);
        } else if (!empty && !this.validation.exportStreamName.invalid && this.validation.exportStreamName.hasValidCharacters) {
            this.isBusyMessage = `Validating Export Name ...`;
            this.exportStreamNameDescriptionComponent.name = this.extraOptions.exportStreamName = name;
            this.validateName(this.exportStreamNameDescriptionComponent);
            this.exportNameNeedsValidation = false;
        }
    }

    validateName(nameDescriptionComponent: NameDescriptionComponent, name?: string, isItemClick?: boolean): Promise<any> {
        const request = new DeferredPromise<any>();
        let trimmedName = '';
        if (name) {
            trimmedName = name.trim();
        } else if (nameDescriptionComponent.name) {
            trimmedName = nameDescriptionComponent.name.trim();
        }
        this.extraOptions.exportStreamName = trimmedName;

        if (trimmedName &&
            nameDescriptionComponent.validateNameError == null && nameDescriptionComponent.validateNameRequest &&
            nameDescriptionComponent.validateNameRequest.endpoint) {
            const requestMessage = nameDescriptionComponent.validateNameRequest.request(trimmedName);
            if (!isNullOrUndefined(requestMessage)) {
                this.isBusy = true;
                this.restService.post(nameDescriptionComponent.validateNameRequest.endpoint, requestMessage).then(response => {
                    this.isBusy = false;
                    nameDescriptionComponent.formValid = true;
                    this.validation.exportStreamName.isNameValidated = true;
                    if (response && !response.valid && !isItemClick) {
                        nameDescriptionComponent.formValid = false;
                        if (response?.reason?.includes('It must be unique within the Project')) {
                            if (trimmedName.length > 20) {
                                response.reason = this.wordWrap(response.reason, 60);
                            }
                            response.reason = response.reason + '\nTo create a new volume, please select a stream from the list.'
                        }
                        this.nameAlreadyExists = this.nameAlreadyExists.concat(trimmedName);
                        nameDescriptionComponent.validateNameError = response.reason;
                        this.validation.exportStreamName.errorMessage = this.exportStreamNameDescriptionComponent.validateNameError;
                        this.validation.exportStreamName.invalid = true;
                        this.validation.exportStreamName.hasError = true;
                        this.validation.exportStreamName.errorType = 'error';
                        this.setExportNameState(false);
                    }

                    this.isBusyMessage = ``;
                    request.resolve(response);
                }, error => { this.isBusy = false; });
            }
        }
        return request.promise;
    }

    wordWrap(str, maxWidth): string {
        const newLineStr = '\n';
        let done = false;
        let res = '';
        do {
            let found = false;
            // Inserts new line at first whitespace of the line
            for (let i = maxWidth - 1; i >= 0; i--) {
                if (this.whitespace(str.charAt(i))) {
                    res = res + [str.slice(0, i), newLineStr].join('');
                    str = str.slice(i + 1);
                    found = true;
                    break;
                }
            }
            // Inserts new line at maxWidth position, the word is too long to wrap
            if (!found) {
                res += [str.slice(0, maxWidth), newLineStr].join('');
                str = str.slice(maxWidth);
            }

            if (str.length < maxWidth) {
                done = true;
            }
        } while (!done);

        return res + str;
    }

    whitespace(string): any {
        const white = new RegExp(/^\s$/);
        return white.test(string.charAt(0));
    }

    setNameDescriptionComponentName(nameDescriptionComponent: NameDescriptionComponent): void {
        nameDescriptionComponent.setOriginalName(nameDescriptionComponent.name);
        nameDescriptionComponent.formValid = !!nameDescriptionComponent.name;
    }

    setExportNameState(valid: boolean): void {
        // assume valid
        this.validation.exportStreamName.hasValidCharacters = true;
        this.exportStreamNameDescriptionComponent.formValid = true;
        this.validation.exportStreamName.invalid = false;

        if (valid === false) {
            this.validation.exportStreamName.hasValidCharacters = false;
            this.exportStreamNameDescriptionComponent.formValid = false;
            this.validation.exportStreamName.invalid = true;
        }

        if (this.isItemClick) {
            this.validation.exportStreamName.hasValidCharacters = true;
            this.exportStreamNameDescriptionComponent.formValid = true;
            this.validation.exportStreamName.invalid = false;
        }
    }

    setTableNameState(valid: boolean): void {
        // assume valid
        this.validation.tableName.hasValidCharacters = true;
        this.tableNameDescriptionComponent.formValid = true;
        this.validation.tableName.invalid = false;
        this.validation.tableName.hasError = false;

        if (valid === false) {
            this.validation.tableName.hasValidCharacters = false;
            this.tableNameDescriptionComponent.formValid = false;
            this.validation.tableName.invalid = true;
            this.validation.tableName.hasError = true;
        }
    }

    tableNameCheck() {
        this.tableNameDescriptionComponent.name = this.exportOptions.tableName;
        this.tableNameDescriptionComponent.validateNameError = null;
        this.validation.tableName.hasError = false;
        const empty = DrObject.isEmpty(this.tableNameDescriptionComponent.name);
        if (empty) {
            this.validation.tableName.errorMessage = `Please specify the DB Table Name.`;
            this.validation.tableName.hasError = true;
            this.setTableNameState(false);
        } else {
            this.tableNameCheckCharacters(this.tableNameDescriptionComponent.name, empty);
        }
        if (!this.validation.tableName.errorMessage?.includes('Up to')) {
            this.validation.tableName.errorType = 'error';
        }
    }

    tableNameCheckCharacters(name: string, empty: boolean) {
        if (!empty) {
            this.validation.tableName.hasValidCharacters = false;
            this.tableNameDescriptionComponent.onNameChanged();
            this.setTableNameState(this.tableNameDescriptionComponent.formValid);
            if (!this.tableNameDescriptionComponent.formValid) {
                this.validation.tableName.errorMessage = this.tableNameDescriptionComponent.validateNameError;
                this.validation.tableName.hasError = true;
                this.setTableNameState(false);
            }
        }
    }

    tableNameValidateName() {
        this.validateTableName();
        if (!this.isBusy) {
            this.exportOptions.tableName = this.tableNameDescriptionComponent.name;
            if (!this.tableNameDescriptionComponent.formValid) {
                this.validation.tableName.errorMessage = this.tableNameDescriptionComponent.validateNameError;
                this.validation.tableName.invalid = true;
            }
        }
    }

    tableNameCheckForErrors() {
        if (!DrObject.isEmpty(this.tableNameDescriptionComponent.name) && !this.tableNameDescriptionComponent.formValid) {
            this.validation.tableName.errorMessage = this.tableNameDescriptionComponent.validateNameError;
            this.validation.tableName.invalid = true;
        }
    }

    formatTableName(projectName: string, exportStreamName: string) {
        // remove leading, trailing, and embedded white spaces
        const formattedProjectName = projectName.replace(/ /g, '_').trim();
        const formattedExportStreamName = exportStreamName.replace(/ /g, '_').trim();
        let formattedTableName = `DR_${formattedProjectName}_${formattedExportStreamName}`;

        if (formattedTableName.length > this.maxTableNameLength) {
            formattedTableName = formattedTableName.substring(0, this.maxTableNameLength);
        }

        // validate name
        this.validation.tableName.errorMessage = null;
        this.exportOptions.tableName = formattedTableName;
        this.tableNameCheck();
        return;
    }

    getExportDatabaseConnection() {
        this.isBusy = true;
        this.isBusyMessage = 'Checking export database connection...';
        this.restService.post(Endpoint.projectManager_getExportOptions, { projectHandle: this.commonService.currentProject?.handle }).then(response => {
            this.isBusy = false;
            if (response && response.exportSettings.selectedExportDatabaseConnection) {
                this.extraOptions.selectedExportDatabaseConnection = response.exportSettings.selectedExportDatabaseConnection;
                if (response.exportSettings && response.exportSettings.tableName) {
                    this.tableNameDescriptionComponent.name = response.exportSettings.tableName;
                }

                if (isNullOrUndefined(this.tableNameDescriptionComponent.name) || DrObject.isEmpty(this.tableNameDescriptionComponent.name)) {
                    this.formatTableName(this.commonService.currentProject?.name, this.extraOptions.exportStreamName);
                }

                this.validation.tableName.invalid = !this.tableNameDescriptionComponent.formValid;
                this.tableNameNeedsValidation = false;
                this.markAsDirty();
            } else {
                this.commonService.openErrorModal('No database connection has been selected in the "Export\nDatabase" dropdown in Project Settings > Export Settings.');
                this.exportOptions.exportToDb = false;
            }
        }, error => {
            this.isBusy = false;
            this.exportOptions.exportToDb = false;
        });
    }

    setDBTableStates() {
        this.isSQLCheckboxDisabled();
        this.isTableNameDisabled();
    }

    isTableNameDisabled(): boolean {
        if ((this.isExportVolume && this.exportOptions.exportToDb === true)) {
            return false;
        }
        return true;
    }

    isSQLCheckboxDisabled(): boolean {
        if (this.isNewExport) {
            return false;
        }
        return true;
    }

    listFocusOut = (event?: any) => {
        if (event) {
            this.commonService.sendMessage(MessageType.outsideScrollClick);
        }
    }

    openDocumentFolderModal() {
        if (this.exportOptions?.reviewProjectId > 0) {
            const reviewProjectName = this.availableReviewProjects?.find(p => p.reviewProjectId === this.exportOptions?.reviewProjectId)?.reviewProjectName;
            const projectInfo = { name: reviewProjectName, id: this.exportOptions?.reviewProjectId, reviewSystem: this.currentReviewSystem };

            this.commonService.openModal(SelectDocumentFolderModalComponent, { class: 'vertical-px-700 horizontal-px-538', modalData: { reviewProjectInfo: projectInfo } }).then(response => {
                if (response?.modalData) {
                    let reviewFolderPath = '';
                    if (response.modalData instanceof GenericTreeNode) {
                        reviewFolderPath = response.modalData.data?.name ? response.modalData.data.name.replace(/\//g, ' \\ ') : '';
                        this.exportOptions.reviewFolderId = response.modalData.data?.id;
                        this.exportOptions.reviewFolderName = response.modalData.data?.name;
                    } else {
                        reviewFolderPath = response.modalData.parentFolderName + ' \\ ' + (response.modalData.subfolder?.data?.name ? response.modalData.subfolder.data.name.replace(/\//g, ' \\ ') : '');
                        this.exportOptions.reviewFolderId = response.modalData.subfolder?.data?.id;
                        this.exportOptions.reviewFolderName = response.modalData.parentFolderName + '\\' + response.modalData.subfolder?.data?.name;
                    }
                    this.isFolderPathSelected = true;
                    this.documentFolderPath = 'All Document Folders \\ ' + reviewFolderPath;
                    const isAllDocs = reviewFolderPath === 'All Document Folders';
                    this.documentFolderPath = reviewFolderPath === '' || isAllDocs ? 'All Document Folders' : this.documentFolderPath;
                    this.selectedFolderPath = this.documentFolderPath;
                    this.exportOptions.reviewFolderPath = this.documentFolderPath;
                    this.validation.documentFolder.check();
                }
            });
        }
    }

    ngOnDestroy(): void {
        if (this.focusFieldEvent) { 
            this.focusFieldEvent.unsubscribe();
        }
    }
}
